{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "アクセントと特殊文字",
  "account": "アカウント",
  "activity": "アクティビティ",
  "actor": "アクター {{number}}",
  "actor_2": "演者 2",
  "actor_name": "アクター名",
  "actor_voice": "アクターの音声",
  "add_alternatives": "代替案を追加",
  "add_another_reply": "返信を追加",
  "add_answer": "回答を追加",
  "add_courses": "コースを追加",
  "add_image": "画像を追加",
  "add_image_desc": "課題に画像を追加してください！",
  "add_link": "リンクを追加",
  "add_link_desc": "課題にリンクを追加してください！",
  "all_steps_complete": "すべてのステップが完了しました",
  "alternative_versions": "別のバージョン",
  "archive_recording_error": "録音のアーカイブ中に問題が発生しました",
  "assign": "割り当てる",
  "attach_file": "ファイルを添付",
  "bot_not_found": "チャットボットが見つかりません",
  "bot_not_found_desc": "このチャットボットが見つかりませんでした。削除されたか、非公開になっている可能性があります。",
  "build_meaning": "意味を組み立てる",
  "categories": "カテゴリ",
  "chart": "グラフ",
  "choose_length_of_roleplay": "シナリオの長さを選択してください",
  "clear": "クリア",
  "close_pdf": "PDF を閉じる",
  "comma_seperated_domains": "カンマ区切りのドメイン",
  "community": "コミュニティ",
  "datetime": "日時",
  "days": "日",
  "days_late": "{{count}} 日遅れ",
  "discussion": "ディスカッション",
  "download_error": "ファイルのダウンロード中に問題が発生しました",
  "editor": "エディター",
  "editor_mode": "エディターモード",
  "email_notifications": "メール通知",
  "enter_linguistic_goal": "言語学習の目標を入力",
  "add_new": "新規追加",
  "add_phrase": "フレーズを追加",
  "add_phrase_desc": "学習者向けの新しい{{language}}フレーズを追加",
  "add_phrases": "フレーズを追加",
  "add_phrases_to_enable_exercise": "課題を有効にするにはフレーズを追加してください",
  "add_question": "質問を追加",
  "add_question_desc": "理解度確認の質問を追加してください。質問には複数の正答があります。回答の順序は課題中に表示される順序です。",
  "add_review": "レビューを追加",
  "add_review_desc": "下記にご意見をお聞かせください",
  "add_script": "スクリプトを追加",
  "add_section": "セクションを追加",
  "add_substitution": "置き換えを追加",
  "add_substitution_desc": "置き換え機能により、「what's」を「what is」に展開するなど、ユーザーメッセージへの返答をより適切に制御できます！",
  "add_topic": "トピックを追加",
  "add_topic_desc": "トピックはトリガーの論理的なグループです。ユーザーがトピック内にいる場合、そのトピックに属するトリガーのみがマッチします。",
  "add_topic_to_section": "{{sectionId}}セクションにトピックを追加",
  "add_trigger": "トリガーを追加",
  "add_trigger_desc": "トリガーはユーザーメッセージとマッチするテキスト行です。",
  "add_variable": "変数を追加",
  "add_variable_desc": "チャットボット変数はあなたのチャットボットを説明する情報です。チャットボット変数を使用することで、チャットボットがユーザーに自己紹介する返答を書くことができます。",
  "add_voice": "音声を追加",
  "all": "すべて",
  "all_topics_completed": "すべてのトピック完了",
  "alternatives": "代替案",
  "alternatives_desc": "あなたのチャットボットで再利用できる単語やフレーズのリスト。",
  "alternatives_name": "名前",
  "alternatives_value": "単語リスト（カンマ区切り）",
  "answer": "回答",
  "new_answer_placeholder": "ここに回答を入力してください",
  "answer_message_100": "完璧です、よくできました",
  "answer_message_90": "順調に進んでいます、がんばってください",
  "answer_message_95": "惜しい、もう少しです",
  "answer_message_wrong": "ちょっと違いました",
  "answer_method": "回答方法",
  "answers": "回答",
  "attempt": "本番",
  "attempt_info": "テスト情報",
  "attempt_messages": "課題への挑戦",
  "attempt_table": "挑戦",
  "auto_translate": "学習者がメッセージを母国語に翻訳することを許可",
  "auto_translate_phrase": "フレーズを自動翻訳",
  "auto_generate_phrase_translation": "翻訳を生成",
  "avg_pronunciation_score": "平均発音スコア",
  "average_pronunciation_score_tooltip": "平均発音スコアは",
  "B1": "B1",
  "B2": "B2",
  "back": "戻る",
  "back_to_course": "コースに戻る",
  "blog": "ブログ",
  "bot": "チャットボット",
  "bot-listen-and-speak": "チャットボット - 聞いて話す",
  "all_modes": "すべてのモード",
  "bot_information": "チャットボット情報",
  "bot_intro_message": "チャットボットの紹介メッセージ",
  "bot_intro_message_helper_text": "学習者に会話を始めさせたい場合は空白にしてください。",
  "bot_name": "チャットボット名",
  "bot_outputs": "チャットボット出力",
  "bot_reply": "チャットボットの返答",
  "bot_settings": "チャットボット設定",
  "bot_title": "チャットボットタイトル",
  "bot_voice": "チャットボット音声",
  "bots": "チャットボット",
  "bots_not_found_desc": "今日最初のチャットボットを作成しましょう",
  "bots_not_found_title": "チャットボットが見つかりません",
  "C1": "C1",
  "C2": "C2",
  "cancel": "キャンセル",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "アプリの色を変更",
  "change_language": "言語を変更",
  "chatbot_exercise_desc": "ガイド付きプロンプトで会話を練習します。",
  "chatbots": "チャットボット",
  "choose_avatar": "ヌアラを選択",
  "choose_from_file": "ファイルから選択",
  "classroom_code": "クラスルームコード",
  "classroom_code_label": "クラスルームコードを入力",
  "classroom_code_not_valid": "クラスルームコードが無効です",
  "classroom_created": "クラスルームが作成されました",
  "classroom_deleted": "クラスルームが削除されました",
  "classroom_information": "クラスルーム情報",
  "classroom_name": "クラスルーム名",
  "classroom_not_found": "クラスルームが見つかりません",
  "classroom_not_found_desc": "このクラスルームは削除された可能性があります",
  "classroom_load_error": "クラスルームを読み込めませんでした",
  "classroom_load_error_desc": "このクラスルームの読み込み中に問題が発生しました。もう一度お試しください。",
  "classroom_settings": "クラスルーム設定",
  "classrooms": "クラスルーム",
  "classrooms_not_found_desc": "今日最初のクラスルームを作成しましょう",
  "classrooms_not_found_title": "クラスルームが見つかりません",
  "collaborators": "協力者（任意）",
  "color": "色",
  "community_templates": "コミュニティテンプレート",
  "completed": "完了",
  "completed_icon": "完了アイコン",
  "completion": "完了",
  "completions": "完了",
  "confirmation": "確認",
  "contact_form": "お問い合わせ",
  "continue": "続行",
  "continue_exercise": "課題を続ける",
  "continue_learning": "学習を続ける",
  "continue_teaching": "指導を続ける",
  "copied": "コピーされました",
  "copy_to_clipboard": "クリップボードにコピー",
  "correct": "正解",
  "correct_answer": "正しい回答",
  "correct_answer_percentage": "正答率",
  "course": "コース",
  "course_code": "コースコード",
  "course_code_label": "コースコードを入力",
  "course_code_not_valid": "コースコードが無効です",
  "course_created": "コースが作成されました",
  "course_deleted": "コースが削除されました",
  "course_information": "コース情報",
  "course_name": "コース名",
  "course_not_found": "コースが見つかりません",
  "course_not_found_desc": "このコースは削除された可能性があります",
  "course_outline": "コース概要",
  "course_progress": "コース進捗",
  "course_settings": "コース設定",
  "courses": "コース",
  "courses_not_found_desc": "今日最初のコースを作成しましょう",
  "courses_not_found_title": "コースが見つかりません",
  "create": "作成",
  "create_bot": "チャットボットを作成",
  "create_classroom": "クラスルームを作成",
  "create_course": "コースを作成",
  "create_course_section": "コースセクションを作成",
  "create_course_section_desc": "コースの構成は自由です。例：「初級、中級、上級」や「第1週、第2週、第3週」",
  "create_duplicate": "複製を作成",
  "create_topic": "トピックを作成",
  "created_courses": "作成済みコース",
  "creation_visibility": "公開コンテンツは他の教育者の作成の出発点として使用できます。",
  "creator": "作成者",
  "creator_instructions": "教師向け指示",
  "creator_instructions_placeholder": "コース協力者向けのフォーマットされた指示メッセージをここに追加できます\n\n例：「チャットボットへようこそ。学習者向けにこのチャットボットをカスタマイズする方法は...」",
  "customization": "カスタマイズ",
  "dark_theme": "ダークテーマ",
  "dark_theme_desc": "ページの明るい表面を暗くし、夜に最適な体験を作成します。",
  "date": "日付",
  "delete_bot": "チャットボットを削除",
  "delete_bot_confirmation": "このチャットボットを削除してもよろしいですか？",
  "delete_classroom": "クラスルームを削除",
  "delete_classroom_confirmation": "このクラスルームを削除してもよろしいですか？",
  "delete_course": "コースを削除",
  "delete_course_confirmation": "このコースを削除してもよろしいですか？",
  "delete_phrase": "フレーズを削除",
  "delete_phrase_confirmation": "このフレーズを削除してもよろしいですか？",
  "delete_picture": "画像を削除",
  "delete_review": "レビューを削除",
  "delete_review_confirmation": "このレビューを削除してもよろしいですか？",
  "delete_roleplay": "シナリオを削除",
  "delete_roleplay_confirmation": "このシナリオを削除してもよろしいですか？",
  "delete_section": "セクションを削除",
  "delete_section_confirmation": "このセクションを削除してもよろしいですか？",
  "delete_topic": "トピックを削除",
  "delete_topic_confirmation": "このトピックを削除してもよろしいですか？",
  "description": "説明",
  "difficulty": "難易度",
  "difficulties": "難易度一覧",
  "disable": "無効化",
  "disabled": "無効",
  "display": "表示",
  "display_classroom_code": "クラスルームコードを表示",
  "download_csv_file": "ダウンロード",
  "drop_csv_file_or_click_to_upload": "CSVファイルをドロップするかクリックしてアップロードしてください。",
  "edit": "編集",
  "edit_bot": "チャットボットを編集",
  "edit_discussion": "ディスカッションを編集",
  "edit_roleplay": "シナリオを編集",
  "email": "Eメール",
  "enable": "有効化",
  "enabled": "有効",
  "enrolment_key": "登録キー",
  "enrolment_key_not_valid": "登録キーが無効です",
  "enter_private_key": "登録キーを入力",
  "error_generating_discussion": "ディスカッションの生成中に問題が発生しました",
  "exercise": "課題",
  "exercise_complete": "課題完了",
  "exercise_completed_icon": "{{name}} を {{counter}} 回完了",
  "exercise_completion": "{{exercise}} 課題 '{{id}}' を完了しました",
  "exercise_in_progress": "{{exercise}} 課題 '{{id}}' を開始しました",
  "exercise_info": "課題情報",
  "exercise_no_longer_available": "この課題はもう利用できません",
  "exercises": "課題",
  "exercises_completed": "完了した課題",
  "exercise_progress_bar": "課題進捗バー",
  "exercises_completed_icon": "{{name}} を {{counter}} 回完了",
  "exit": "終了",
  "expand": "展開",
  "fill_in_contact_form": "下記のフォームにご記入ください",
  "find_bot": "チャットボットを検索",
  "find_classroom": "クラスルームを検索",
  "find_course": "コースを検索",
  "find_roleplay": "シナリオを検索",
  "finish": "完了",
  "finish_exercise": "課題を完了",
  "for_lang": "私の言語",
  "formatting_options": "フォーマットオプション",
  "fri": "金",
  "from": "から",
  "fullscreen": "全画面",
  "generate_definitions_info": "このリストのフレーズの定義を生成します。",
  "generating": "生成中",
  "get_started": "開始",
  "go_back": "戻る",
  "go_back_to_topic": "トピックに戻る",
  "go_to": "移動",
  "go_to_settings": "設定へ移動",
  "group_information_form_title": "グループについて教えてください",
  "group_member_limit": "グループメンバー上限",
  "group_name": "グループ名",
  "group_picture": "グループ画像",
  "group_subscription_form_title": "グループのサブスクリプションを設定",
  "help": "ヘルプ",
  "hidden": "非表示",
  "hide": "非表示",
  "hide_bot": "チャットボットを隠す",
  "hide_chatbots_exercise": "ボットを隠す",
  "hide_listening_exercise": "リスニング課題を隠す",
  "hide_menu": "メニューを隠す",
  "hide_options": "オプションを隠す",
  "hide_pronunciation_exercise": "発音課題を隠す",
  "hide_roleplay": "シナリオを隠す",
  "hide_roleplays_exercise": "シナリオを隠す",
  "hide_section": "セクションを隠す",
  "hide_topic": "トピックを隠す",
  "hide_translation_exercise": "翻訳課題を隠す",
  "hide_word_bank": "単語バンクを隠す",
  "hide_from_students": "学習者から隠す",
  "home": "ホーム",
  "how_to_join_find_button": "{{button}} ボタンを探してクリックしてください。",
  "how_to_join_get_ready": "準備をしてください。",
  "how_to_join_intro": "ゲームに参加するには、次の手順に従ってください:",
  "how_to_join_open_classroom": "クラスルーム {{classroom}} を開くか、下のQRコードをスキャンしてください",
  "how_to_join_sign_in": "アカウントにサインインします。",
  "how_to_join_title": "ゲームへの参加方法",
  "in_game": "参加中",
  "in_progress": "プレイを続ける",
  "incorrect": "不正解",
  "insert_bold": "太字を挿入",
  "insert_italic": "斜体を挿入",
  "insert_link": "リンクを挿入",
  "insert_photo": "写真を挿入",
  "instruction_message": "指示",
  "interculturarity": "異文化理解",
  "join": "参加",
  "join_classroom": "クラスルームに参加",
  "join_code_desc": "学習者は以下のコードを使って参加できます",
  "join_course": "コースに参加",
  "join_date": "参加日",
  "joined": "参加しました",
  "joined_classroom": "クラスルームに参加しました",
  "joined_course": "コースに参加しました",
  "language": "言語",
  "language_phrase": "{{language}} フレーズ",
  "language_translation": "{{language}} 翻訳",
  "learn": "学習",
  "learn_for_speakers_of": "{{forLang}}話者向け{{learnLang}}",
  "learn_lang": "学習したい言語",
  "loading": "読み込み中",
  "loading_topics": "トピックを読み込み中",
  "meaning-listen-and-speak": "意味 - 聞いて話す",
  "meaning-read-and-write": "意味 - 読んで書く",
  "meaning_listen_and_speak": "聞いて話す",
  "meaning_listen_and_speak_exercise_desc": "定義を聞いて、一致するフレーズを話しましょう。",
  "more_definitions": "その他の定義",
  "more_translations": "その他の翻訳",
  "new": "新着",
  "no_archived_discussions": "アーカイブされたディスカッションはありません",
  "no_chatbot_templates": "利用できるテンプレートがありません",
  "no_discussions": "ディスカッションはありません",
  "no_discussions_description": "ディスカッションは、生徒が協力して会話することで学習に取り組める優れた方法です。ディスカッションを作成して、スピーキングの練習、自信の育成、コミュニケーション能力の向上に役立てましょう。",
  "no_past_due_assignments": "期限切れの課題はありません",
  "no_past_due_discussions": "期限切れのディスカッションはありません",
  "no_phrases": "フレーズがありません",
  "no_scheduled_assignments": "予定されている課題はありません",
  "no_topics_available": "利用できるトピックがありません",
  "not_in_game": "未参加",
  "nudge_add_family_name_field_desc": "先生があなたを識別できるように姓を追加してください。",
  "nudge_add_family_name_profile_desc": "先生があなたを識別できるようにプロフィールに姓を追加してください。",
  "nudge_add_family_name_title": "姓を追加",
  "on": "日付",
  "open_image_library": "画像ライブラリを開く",
  "perfect_click_finish_create_group": "完璧です。「完了」をクリックしてグループを作成してください。",
  "phrase_definition": "フレーズの定義",
  "phrase_definition_helper_text": "Enter キーを押して定義を追加します。",
  "phrase_group_game_in_progress_icon": "{{name}} 進行中",
  "phrase_lists_error": "フレーズリストの読み込み中に問題が発生しました",
  "player": "人",
  "players": "人",
  "please_select_a_textfield": "テキストフィールドを選択してください",
  "preview_pdf": "PDF をプレビュー",
  "print": "印刷",
  "questions": "質問",
  "read_and_write": "読んで書く",
  "recommended": "おすすめ",
  "record_unsupported": "このブラウザでは録音がサポートされていません",
  "refresh": "更新",
  "result": "結果",
  "retry": "再試行",
  "roleplay_not_found": "シナリオが見つかりません",
  "roleplay_not_found_desc": "このシナリオが見つかりませんでした。削除されたか、非公開になっている可能性があります。",
  "save_definitions_error": "定義の保存中に問題が発生しました",
  "scenarios": "シナリオ",
  "schedule": "スケジュール",
  "script_not_found": "スクリプトが見つかりません",
  "script_not_found_desc": "このスクリプトが見つかりませんでした。削除されたか、非公開になっている可能性があります。",
  "search_images": "画像を検索",
  "see_more_pronunciations": "他の発音を見る",
  "send": "送信",
  "show_phrase_list": "フレーズリストを表示",
  "student_limit": "生徒数の上限",
  "submit": "送信",
  "submitting": "送信中",
  "subscription": "サブスクリプション",
  "subscription_period_end": "サブスクリプション期間の終了",
  "subscription_status": "サブスクリプションの状態",
  "table": "表",
  "teach": "指導",
  "leave_classroom": "クラスルームを退出",
  "leave_classroom_confirmation": "このクラスルームを退出してもよろしいですか？",
  "leave_course": "コースを退出",
  "leave_course_confirmation": "このコースを退出してもよろしいですか？",
  "left_classroom": "クラスルームを退出しました",
  "left_course": "コースを退出しました",
  "lets_begin": "始めましょう",
  "library": "ライブラリ",
  "link_name": "リンク名",
  "link_name_helper_text": "リンクの表示名を入力",
  "link_value": "リンクURL",
  "link_value_helper_text": "リンクのURLを入力",
  "listen_to_this_phrase": "この{{language}}フレーズを聞いてください",
  "listener": "リスナー",
  "listener_dialog_desc": "発音を聞くために下記の音声を選択",
  "listening": "リスニング",
  "listening_exercise_desc": "聞いたフレーズを認識し理解します。",
  "load_more_events": "さらにイベントを読み込む",
  "logout": "ログアウト",
  "manage_course": "コース管理",
  "members": "学習者",
  "members_not_found": "学習者なし",
  "members_not_found_desc": "学習者が見つかりませんでした",
  "message": "メッセージ",
  "method": "方法",
  "missing_details": "詳細が不足しています",
  "mon": "月",
  "more_options": "その他のオプション",
  "my_courses": "マイコース",
  "name": "名前",
  "new_bots": "新しいチャットボット",
  "new_courses": "新しいコース",
  "new_roleplays": "新しいシナリオ",
  "next": "次へ",
  "next_with_progress": "次へ ({current}/{total})",
  "no_activity_found": "アクティビティが見つかりません",
  "no_courses_found": "コースが見つかりません",
  "no_results_found": "結果が見つかりません",
  "nualang_templates": "テンプレート",
  "only_available_on_chrome": "Chromeでのみ利用可能",
  "open_in_google_sheets": "Google スプレッドシートで開く",
  "open_search_student_name_filters": "学習者名検索フィルターを開く",
  "option": "オプション",
  "optional": "任意",
  "or_choose_from_one_of_the_following": "または以下から選択",
  "percentage_complete": "完了率",
  "phrase": "フレーズ",
  "phrases": "フレーズ",
  "play_again": "もう一度プレイ",
  "plays": "{{number}}回プレイ",
  "popular_courses": "人気のコース",
  "preview": "プレビュー",
  "previous": "前へ",
  "private": "プライベート",
  "problem": "問題が発生しました",
  "problem_creating": "作成中に問題が発生しました",
  "problem_deleting": "削除中に問題が発生しました",
  "problem_getting_reply": "返答の取得中に問題が発生しました",
  "problem_loading": "読み込み中に問題が発生しました",
  "problem_sending_contact_form": "問い合わせフォーム送信中に問題が発生しました",
  "profile": "プロフィール",
  "profiles": "プロフィール",
  "progress_icon": "進捗アイコン",
  "pronounce_this_phrase": "このフレーズを発音してください",
  "pronunciation": "発音",
  "pronunciation_exercise_desc": "自然で明瞭なフレーズの発話練習をします。",
  "public": "公開",
  "question": "質問",
  "new_question_placeholder": "ここに質問を入力してください",
  "quit": "終了",
  "record_message": "メッセージを録音",
  "records": "記録",
  "redo_action": "やり直し",
  "remove": "削除",
  "remove_card": "カードを削除",
  "remove_bot": "チャットボットを削除",
  "remove_roleplay": "シナリオを削除",
  "remove_classroom_member": "クラスルーム学習者を削除",
  "remove_classroom_member_confirmation": "この学習者をクラスルームから削除してもよろしいですか",
  "remove_member": "学習者を削除",
  "member_removed_from_classroom": "学習者がクラスルームから削除されました",
  "reply": "返答",
  "reply_options": "返答オプション",
  "reply_options_are_disabled": "返答オプションが無効になっています",
  "reply_options_desc": "学習者がオプションリストから正しい返答を選択できるようにします",
  "report_views": "視聴数",
  "required_for_private_classrooms": "プライベートクラスルームに必要",
  "required_for_private_courses": "プライベートコースに必要",
  "reset": "リセット",
  "restart_exercise": "課題を再開",
  "return_to_course": "コースに戻る",
  "review_content": "レビュー内容",
  "review_title": "レビュータイトル",
  "reviews": "レビュー",
  "reviews_not_found": "レビューなし",
  "reviews_not_found_desc": "レビューが見つかりませんでした",
  "role_played": "演じた役割",
  "roleplay": "シナリオ",
  "roleplay_exercise_desc": "シーンに入り込み対話練習をします。",
  "roleplays_not_found_desc": "今日最初のシナリオを作成しましょう",
  "roleplay_information": "シナリオ情報",
  "roleplay_name": "シナリオ名",
  "roleplay_settings": "シナリオ設定",
  "roleplays": "シナリオ",
  "sat": "土",
  "save_changes": "変更を保存",
  "save_progress": "進捗を保存",
  "show_progress": "進捗を表示",
  "script": "スクリプト",
  "search": "検索",
  "search_for_student": "学習者を検索",
  "section": "セクション",
  "section_name": "セクション名",
  "section_visibility": "セクション表示",
  "sections_not_found": "セクションが見つかりません",
  "sections_not_found_desc": "",
  "select_a_template": "テンプレートを選択",
  "select_file": "ファイルを選択",
  "select_file_desc": "ここにファイルをドロップするかクリックしてマシンを参照",
  "select_files": "ファイルを選択",
  "select_the_from_date": "開始日を選択",
  "select_the_to_date": "終了日を選択",
  "settings": "設定",
  "share": "共有",
  "share_via": "共有方法",
  "show_bot": "チャットボットを表示",
  "show_chatbots_exercise": "ボットを表示",
  "show_listening_exercise": "リスニング課題を表示",
  "show_menu": "メニューを表示",
  "show_options": "オプションを表示",
  "show_pronunciation_exercise": "発音課題を表示",
  "show_roleplay": "シナリオを表示",
  "show_roleplays_exercise": "シナリオを表示",
  "show_section": "セクションを表示",
  "show_topic": "トピックを表示",
  "show_translation_exercise": "翻訳課題を表示",
  "show_word_bank": "単語バンクを表示",
  "show_to_students": "学習者に表示",
  "skip": "スキップ",
  "skip_copy_topic": "スキップ",
  "skipped": "スキップしました",
  "speak": "話す",
  "speakers_of": "話者",
  "start": "開始",
  "start_course": "コースを開始",
  "stop": "停止",
  "stop_recording": "録音停止",
  "student_instructions": "学習者向け指示",
  "student_instructions_placeholder": "学習者向け指示：\nフォーマットされた指示メッセージをここに追加できます\n\n例：「チャットボットへようこそ、helloと入力して始めてください」",
  "subject": "件名",
  "substitution_desc": "トリガーをチェックする前にユーザーメッセージを変更します。",
  "substitution_name": "元のテキスト",
  "substitution_name_helper_text": "ユーザーメッセージに出現する可能性のある元のテキスト",
  "substitution_value": "置換テキスト",
  "substitution_value_helper_text": "特殊記号や句読点を含まず、小文字にする必要があります",
  "substitutions": "置換",
  "sun": "日",
  "text": "テキスト",
  "thank_you_for_submitting": "ご送信いただき、ありがとうございます。できるだけ早くご連絡いたします。",
  "the_default_topic_is_random": "デフォルトのトピックはランダムです",
  "thu": "木",
  "time": "時間",
  "time_spent": "費やした時間",
  "to": "まで",
  "toggle_theme": "ライト/ダークテーマの切り替え",
  "toggle_light": "ライトテーマに切り替え",
  "toggle_dark": "ダークテーマに切り替え",
  "topic": "トピック",
  "topic_code": "トピックコード",
  "topic_desc": "ユーザーがトピック内にいる場合、そのトピックに属するトリガーのみがマッチします。",
  "topic_image": "トピック画像",
  "topic_information": "トピック情報",
  "topic_settings": "トピック設定",
  "topic_title": "トピックタイトル",
  "topic_name": "トピック名",
  "topic_not_found": "トピックが見つかりません",
  "topic_not_found_desc": "このトピックは削除された可能性があります",
  "topics": "トピック",
  "translate": "翻訳",
  "translate_is_disabled": "翻訳が無効になっています",
  "translate_this_phrase": "このフレーズを翻訳してください",
  "translation": "翻訳",
  "translation_exercise_desc": "重要なフレーズの理解度を確認します。",
  "translations": "翻訳",
  "trigger_value": "トリガーテキスト",
  "trigger_value_helper_text": "特殊記号や句読点を含まず、小文字にする必要があります",
  "triggers": "トリガー",
  "triggers_desc": "トリガーはユーザーメッセージとマッチするテキスト行です。",
  "tue": "火",
  "type": "種類",
  "unarchive": "アーカイブを解除",
  "undo_action": "元に戻す",
  "update": "更新",
  "update_image": "画像を更新",
  "update_link": "リンクを更新",
  "update_phrase": "フレーズを更新",
  "update_phrase_desc": "この既存のフレーズに変更を加えます",
  "update_picture": "画像を更新",
  "update_question": "質問を更新",
  "update_question_desc": "理解度確認の質問を追加してください。質問には複数の正答があります。回答の順序は課題中に表示される順序です。",
  "update_recording_error": "録音の更新中に問題が発生しました",
  "update_review": "レビューを更新",
  "update_review_desc": "レビューの説明を更新",
  "update_section": "セクションを更新",
  "update_section_desc": "コースの構成は自由です。例：「初級、中級、上級」や「第1週、第2週、第3週」",
  "update_substitution": "置換を更新",
  "update_topic": "トピックを更新",
  "update_trigger": "トリガーを更新",
  "update_variable": "変数を更新",
  "upgrade": "アップグレード",
  "upload_phrases": "フレーズをアップロード",
  "upload_phrases_desc": "以下の例のようなCSVファイルを作成してアップロードしてください。",
  "upload_phrases_example_phrase_1": "こんにちは",
  "upload_phrases_example_phrase_2": "さようなら",
  "upload_phrases_example_phrase_3": "私の名前は",
  "upload_phrases_example_definition_1": "誰かを挨拶するために使う言葉",
  "upload_phrases_example_definition_2": "誰かと別れるときに使う言葉",
  "upload_phrases_example_definition_3": "自分の名前を伝えるためのフレーズ",
  "upload_script": "スクリプトをアップロード",
  "upload_script_desc": "以下の形式を使用してCSVファイルでシナリオスクリプトをアップロード",
  "use_keyboard": "キーボードを使用",
  "use_word_bank": "単語バンクを使用",
  "user_message": "ユーザーメッセージ",
  "user_updated": "ユーザーが更新されました",
  "variable_desc": "チャットボットで使用できる情報。",
  "variable_name": "変数名",
  "variable_value": "変数値",
  "variables": "変数",
  "vars": "変数",
  "view_activity": "アクティビティを表示",
  "view_instruction_message": "指示を表示",
  "view_outline": "概要を表示",
  "view_progress": "進捗を表示",
  "view_report": "レポートを表示",
  "visibility": "表示設定",
  "visit_learning_site": "Learning Site にアクセス",
  "voice": "音声",
  "voice_speed_disabled": "この音声では読み上げ速度を変更できません",
  "wed": "水",
  "weekly_progress": "週間進捗",
  "what_do_you_hear": "何が聞こえますか？",
  "word_bank": "単語バンク",
  "active_now": "現在アクティブ",
  "choose_a_language": "言語を選択",
  "manage_classroom": "クラスルーム管理",
  "must_question_least_correct_answer": "質問と少なくとも1つの正答が必要です。",
  "enter_name_your_voice_clip": "音声クリップの名前を入力してください？",
  "my_unnamed_clip": "無題のクリップ",
  "are_you_sure": "本当によろしいですか？",
  "is_already_created_variable_overwrite": "はすでに作成済みの変数です。上書きしますか？",
  "is_already_created_substitution_overwrite": "はすでに作成済みの置換です。上書きしますか？",
  "is_already_created_alternative_overwrite": "はすでに作成済みの代替案です。上書きしますか？",
  "is_already_created_topic_overwrite": "はすでに作成済みのトピックです。上書きしますか？",
  "bring_your_bot_picture_name": "画像と名前を付けてチャットボットに命を吹き込みましょう",
  "perfect_click_finish_create_bot": "完璧です。完了をクリックして新しいチャットボットを作成してください",
  "lets_start_with_some_information_about_your_bot": "チャットボットの情報から始めましょう",
  "lets_start_some_information_about_classroom": "クラスルームの情報から始めましょう",
  "the_language_classroom_teach": "このクラスルームで教える言語",
  "the_language_students_classroom_speak": "このクラスルームの学習者が話す言語",
  "limit_access_classroom_visibility_private_including_enrolment_key": "表示設定をプライベートにし、登録キーを含めることでクラスルームへのアクセスを制限",
  "add_collaborators": "協力者を追加",
  "perfect_click_finish_create_classroom": "完璧です。完了をクリックして新しいクラスルームを作成してください",
  "perfect_click_finish_create_course": "完璧です。完了をクリックして新しいコースを作成してください",
  "lets_start_information_about_course": "コースの情報から始めましょう",
  "the_language_course_teach": "このコースで教える言語",
  "the_language_students_course_speak": "このコースの学習者が話す言語",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "表示設定をプライベートにし、登録キーを含めることでコースへのアクセスを制限",
  "selected": "選択済み",
  "perfect_click_finish_create_roleplay": "完璧です。完了をクリックして新しいシナリオを作成してください",
  "lets_start_with_information_about_roleplay": "シナリオの情報から始めましょう",
  "play_bot": "チャットボットをプレイ",
  "invite": "招待",
  "unanswered_table": "未回答",
  "create_roleplay": "シナリオを作成",
  "roleplays_not_found_title": "シナリオが見つかりません",
  "play": "プレイ",
  "delete": "削除",
  "use_wordbank_if_stuck": "困った時は単語バンクを使用してください",
  "play_bot_error": "おっと！チャットボットに問題が発生しました。もう一度試してください",
  "bot_editor_preview_error": "エラーが発生しました。画面上部のヘルプポップアップ（クエスチョンマークアイコン）を参照してください。",
  "lets_find_a_template": "テンプレートを見つけましょう！",
  "search_by_difficulty": "難易度で検索",
  "search_using_keywords": "キーワードで検索",
  "select_a_nualang_template": "Nualangテンプレートを選択",
  "select_a_nualang_template_desc": "開始をサポートするためにNualangチームが作成したテンプレート。",
  "or_select_a_community_template": "またはコミュニティテンプレートを選択",
  "or_select_a_community_template_desc": "コミュニティテンプレートは世界中の教師により作成されています。",
  "dashboard_welcome": "ようこそ、{{name}}さん！",
  "dashboard_welcome_desc": "探索ページに慣れ親しんでください。こちらが開始方法です。",
  "enter_course_code": "コースコードを入力",
  "enter_course_code_desc": "コースコードをお持ちの場合はここに入力してください。",
  "enter_classroom_code": "クラスルームコードを入力",
  "enter_classroom_code_desc": "クラスルームコードをお持ちの場合はここに入力してください。",
  "search_nualang": "Nualangを探索",
  "search_nualang_desc": "私たちのヌアラと会話を開発する志を同じくする教師のコミュニティが成長しているため、常に新しい学習内容があります。",
  "create_nualang": "独自に作成",
  "create_nualang_desc": "会話と言語レッスンを作成します。",
  "roleplay_editor_welcome": "シナリオエディターの開始",
  "roleplay_editor_options": "オプションを選択",
  "roleplay_editor_options_desc": "ヌアラを選択して新しい行を追加するか、理解度確認質問を追加します。",
  "roleplay_editor_share": "シナリオを共有",
  "roleplay_editor_play": "シナリオをプレイ",
  "bot_editor_welcome": "チャットボットエディターの開始",
  "bot_editor_sidebar": "エディターサイドバー",
  "bot_editor_sidebar_desc": "サイドバーでチャットボットに変更を加えることができます。",
  "bot_editor_flow_chart": "チャットボットフロー",
  "bot_editor_flow_chart_desc": "チャットボットフローはチャットボットの概要を示し、各メッセージの外観をプレビューします。",
  "bot_editor_share": "チャットボットを共有",
  "bot_editor_play": "チャットボットをプレイ",
  "play_roleplay": "シナリオをプレイ",
  "customize_appearance_of_course": "コースの外観をカスタマイズ",
  "customize_appearance_of_classroom": "クラスルームの外観をカスタマイズ",
  "customize_appearance_of_topic": "トピックの外観をカスタマイズ",
  "manage_courses": "コース管理",
  "refresh_courses": "コースを更新",
  "delete_script_item": "スクリプトから項目を削除",
  "delete_script_item_confirmation": "この項目をスクリプトから削除してもよろしいですか？",
  "add_message": "メッセージを追加",
  "resources": "リソース",
  "contact": "お問い合わせ",
  "sign_in": "サインイン",
  "sign_up": "サインアップ",
  "faqs": "よくある質問",
  "guides": "ガイド",
  "back_to_app": "アプリに戻る",
  "notes": "メモ",
  "notes_placeholder": "ここにメモを入力",
  "get_in_touch": "お問い合わせ",
  "get_in_touch_desc": "ご質問やフィードバックはございますか？メッセージをお送りください。",
  "avatar_generator": "アバタージェネレーター",
  "avatar_generator_desc": "個人用のアバターを作成",
  "upload_image": "画像をアップロード",
  "upload_image_desc": "コンピューターから画像をドラッグ＆ドロップ",
  "random": "ランダム",
  "done": "完了",
  "file_size_exceeded": "画像が大きすぎます！以下より小さい画像をアップロードしてください ",
  "image_selection_failed": "その画像を読み込めませんでした。別の画像を試すか、ご自身の画像をアップロードしてください。",
  "remove_course": "コースを削除",
  "courses_joined": "参加したコース",
  "courses_added": "コースを追加しました",
  "problem_adding_courses": "コースの追加中に問題が発生しました",
  "classroom_courses_not_found_title": "まだコースがありません",
  "classroom_courses_not_found_desc": "このクラスルームにはまだコースがありません。",
  "in_progress_activity": "進行中",
  "bot_exercise_welcome": "チャットボット課題の開始",
  "bot_exercise_restart": "チャットボットを再開！",
  "bot_exercise_keyboard_input": "タイプしてください！",
  "bot_exercise_keyboard_input_desc": "キーボードを使用してメッセージを入力します。特殊文字のヘルプが必要、または絵文字を追加したい場合は、便利なボタンをお試しください。",
  "bot_exercise_voice_input": "話してください！",
  "bot_exercise_voice_input_desc": "マイクをクリックして音声を使用し、発音を練習します。",
  "bot_exercise_send_message": "送信してください！",
  "bot_exercise_send_message_desc": "チャットボットにメッセージを送信して会話を開始します。",
  "bot_exercise_audio_only_mic": "話してください！",
  "bot_exercise_audio_only_mic_desc": "マイクをタップして開始します。その後は自然に話すだけで、Nualaが会話の残りを自動的に聞いて応答します。",
  "roleplay_exercise_welcome": "シナリオ課題の開始",
  "roleplay_exercise_read_script": "台詞を覚えてください！",
  "roleplay_exercise_read_script_desc": "会話を読み、単語の発音を聞きます。",
  "roleplay_exercise_select_an_actor": "役割を選択してください！",
  "roleplay_exercise_select_an_actor_desc": "演じたい役割を選択します。",
  "roleplay_exercise_start": "演じてください！",
  "roleplay_exercise_start_desc": "開始をクリックし、キーボードまたは音声を使って選択した役割を演じます。",
  "listening_exercise_welcome": "リスニング課題の開始",
  "listening_exercise_speak": "フレーズを聞いてください！",
  "listening_exercise_speak_desc": "クリックしてフレーズの発音を聞きます。",
  "listening_exercise_voice_options": "異なる音声で聞いてください！",
  "listening_exercise_voice_options_desc": "フレーズを異なる音声で聞きます。",
  "listening_exercise_keyboard_input": "答えを入力してください！",
  "listening_exercise_keyboard_input_desc": "キーボードを使って聞いたフレーズを入力します。",
  "listening_exercise_word_bank": "ヘルプが必要ですか？",
  "listening_exercise_word_bank_desc": "単語バンクを使って正しい答えを選択します。",
  "translation_exercise_welcome": "翻訳課題の開始",
  "translation_exercise_speak": "フレーズを聞いてください！",
  "translation_exercise_speak_desc": "クリックしてフレーズの発音を聞きます。",
  "translation_exercise_read": "フレーズを読んでください！",
  "translation_exercise_read_desc": "翻訳すべきフレーズを読みます。",
  "translation_exercise_keyboard_input": "答えを入力してください！",
  "translation_exercise_keyboard_input_desc": "キーボードを使って翻訳を入力します。",
  "translation_exercise_word_bank": "ヘルプが必要ですか？",
  "translation_exercise_word_bank_desc": "単語バンクを使って正しい答えを選択します。",
  "pronunciation_exercise_welcome": "発音課題の開始",
  "pronunciation_exercise_speak": "フレーズを聞いてください！",
  "pronunciation_exercise_speak_desc": "クリックしてフレーズの発音を聞きます。",
  "pronunciation_exercise_read": "フレーズを読んでください！",
  "pronunciation_exercise_read_desc": "発音すべきフレーズを読みます。",
  "pronunciation_exercise_voice_input": "フレーズを発音してください！",
  "pronunciation_exercise_voice_input_desc": "マイクをクリックして音声を使用し、発音を練習します。",
  "exercise_share": "他の人と共有！",
  "exercise_mute": "音声をミュート！",
  "exercise_skip": "スキップ！",
  "exercise_skip_desc": "次のフレーズに移動します。最後にもう一度試すことができます。",
  "exercise_restart": "再開！",
  "what_would_you_like_to_do": "何をしたいですか？",
  "i_want_to_learn": "学習したい...",
  "i_want_to_teach": "指導したい...",
  "add_alternative_version": "代替版を追加",
  "add_alternative_version_explanation": "正解として認識されるフレーズの代替版を追加します。例：「You're welcome」の代替として「You are welcome」",
  "language_translation_helper_text": "Enter/リターンキーを押して翻訳を追加。",
  "change_roles": "役割を変更しますか？",
  "write_your_feedback_here": "ここにフィードバックを入力してください",
  "yes": "はい",
  "you_are_human": "あなたが人間である場合は、この欄を空欄のままにしてください",
  "you_are_human_check": "あなたが人間であることを確認してください",
  "you_will_lose_your_progress_on_this_exercise": "この課題の進捗が失われます。",
  "confirm": "確認",
  "general": "一般",
  "shuffle_phrases": "フレーズをシャッフル",
  "shuffle_phrases_desc": "課題で質問される順序をランダム化します。",
  "errors": "エラー",
  "missing_translation": "翻訳が不足",
  "missing_phrase": "フレーズが不足",
  "invalid_image_domain": "画像のURLは承認されたNualangドメインのものである必要があります",
  "row": "行",
  "no_valid_type": "種類は「actor」または「question」である必要があります",
  "no_actor_text": "アクターのテキストなし",
  "no_actor_number": "アクターの最後に番号が必要です。例：actor1、actor2",
  "no_question": "質問なし",
  "no_answers_provided": "回答が提供されていません",
  "no_correct_answer_provided": "正答が提供されていません",
  "no_answers": "回答なし",
  "duplicate_topic": "重複するトピック",
  "normal_mode": "通常モード",
  "spreadsheet_mode": "スプレッドシートモード",
  "image": "画像",
  "delete_selected_row": "選択した行を削除",
  "crop_image": "画像をクロップ",
  "crop": "クロップ",
  "zoom": "ズーム",
  "rotate": "回転",
  "hide_preview": "プレビューを隠す",
  "show_preview": "プレビューを表示",
  "try_again": "再試行",
  "subscription_plan_teach": "指導プラン",
  "subscription_plan_teacher_pro": "教師プロ",
  "subscription_plan_basic": "教師ベーシック",
  "subscription_plan": "サブスクリプションプラン",
  "subscription_status_trialing": "無料試用",
  "subscription_status_active": "アクティブ",
  "subscription_status_canceled": "キャンセル済み",
  "subscription_status_undefined": "無料",
  "status": "ステータス",
  "upgrade_plan": "プランをアップグレード",
  "manage_plan": "プランを管理",
  "cancel_plan": "プランをキャンセル",
  "your_plan": "あなたのプラン",
  "plan_cost": "プラン料金",
  "next_billing_date": "現在の期間終了",
  "free": "無料",
  "payment_method": "支払い方法",
  "confidence_score": "信頼度パーセンテージは個々の単語が正しく認識された確率を示します。",
  "first_name": "名",
  "last_name": "姓",
  "role": "役割",
  "school_name": "学校名",
  "school_district": "学区",
  "city": "市",
  "state": "州",
  "send_message": "メッセージを送信",
  "pricing_page_title": "プランを選択",
  "pricing_page_subtitle": "教師、学校、学区向けの料金プラン。",
  "pricing_page_testimonials_title": "教師の声",
  "compare_plans": "プランを比較",
  "features": "機能",
  "upgrade_submit": "アップグレード",
  "upgrade_subscription_desc": "この機能にアクセスするには、アカウントをアップグレードする必要があります。アップグレードをクリックして料金ページに移動します。",
  "upgrade_plan_explanation": "この機能にアクセスするには、アカウントをアップグレードする必要があります。",
  "upgrade_subscription_student": "この機能は教師のみが利用できます。",
  "public_visibility_disabled_wayside": "クラスルームは Wayside Publishing によって管理されているため、非公開のままにする必要があります。",
  "public_visibility_disabled_loading": "サブスクリプションを確認しています。表示が更新されない場合はページを再読み込みしてください。",
  "public_visibility_disabled_trial": "無料トライアル中は公開クラスルームを利用できません。このクラスルームを公開するには有料プランにアップグレードしてください。",
  "creator_not_subscribed": "作成者が現在サブスクライブしていないため、このコンテンツは参加できません。",
  "sign_me_up": "登録する！",
  "free_trial": "無料試用",
  "interactive_demo": "デモを取得",
  "news_and_updates": "ニュースと更新",
  "teacher": "教師",
  "principal": "校長",
  "tutor": "家庭教師",
  "parent": "保護者",
  "student": "学習者",
  "other": "その他",
  "none": "なし",
  "group_subscription_plans": "グループサブスクリプションプラン",
  "group_plan": "グループプラン",
  "leave_group": "グループを退出",
  "joined_subscription": "サブスクリプションに参加",
  "joined_subscription_desc": "{{groupName}}グループのサブスクリプションへようこそ、Teacher PROをご利用いただけます",
  "unable_to_join_subscription": "サブスクリプションに参加できません",
  "unable_to_join_subscription_desc": "サブスクリプションへの参加に問題が発生しました。後でもう一度お試しください。",
  "unable_to_join_subscription_invalid_email_desc": "許可されたメールドメイン（{{allowedDomains}}）のいずれかなしにはこのグループに参加できません",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}'が学習者上限に達しました。グループ管理者に連絡して上限を増やしてください。",
  "moderated_image_dialog": "Nualangで不適切、不要、または不快な画像が検出されたため、より安全なユーザー体験を提供するためブロックしました。別の画像をお試しください。",
  "moderate_title": "画像がブロックされました",
  "recommended_courses": "推奨コース",
  "subscription_status_trialing_expired": "無料試用期間終了",
  "no_public_content_created": "公開コンテンツが作成されていません",
  "content_tags": "タグを追加",
  "enter_info_tags": "下記にカンマ区切りのタグリストを入力してください。",
  "add_tag": "Enter/リターンキーを押してタグを追加",
  "enter_collaborator_email": "下記にカンマまたはスペース区切りのメールアドレスリストを入力してください。協力者はコース、学習者、クラスルーム設定を管理できます。",
  "add_collaborator_tag": "Enter/リターンキーを押して協力者を追加",
  "add_to_classroom": "クラスルームに追加",
  "add_to_classroom_desc": "'{{courseName}}'を{{classroomNames}}に追加。",
  "change_voice_speed": "音声スピードを変更！",
  "extra_fast": "超高速",
  "fast": "高速話者",
  "medium": "通常速度",
  "slow": "少し遅く",
  "extra_slow": "一語ずつ",
  "card_ALL": "すべて",
  "join_classroom_to_access": "アクセスするにはクラスルームに参加",
  "join_course_to_access": "アクセスするにはコースに参加",
  "confidence": "信頼度",
  "teach_lang": "指導したい言語",
  "write_feedback": "フィードバックを書く",
  "allowed_domains": "許可される学校ドメイン（任意）",
  "enter_domains_info": "下記にカンマまたはスペース区切りの学校ドメインリストを入力してください。",
  "add_allowed_domains_desc": "学校ドメインに基づくアクセス制限。例：'schooldomain.com'",
  "send_feedback": "フィードバックを送信",
  "add_feedback": "フィードバックを追加",
  "feedback_content": "フィードバック内容",
  "report_problem": "問題を報告",
  "report_problem_input_label": "問題の説明",
  "update_feedback": "フィードバックを更新",
  "student_completes_exercise": "学習者が課題を完了",
  "delete_feedback_confirmation": "このフィードバックを削除してもよろしいですか？",
  "delete_feedback": "フィードバックを削除",
  "updates_to_our_terms_of_service": "利用規約の更新",
  "email_me_when": "以下の場合にメールを送信：",
  "new_classroom": "新しいクラスルーム",
  "student_progress": "学習者の進捗",
  "view_course": "コースを表示",
  "view_section": "セクションを表示",
  "classroom_members_not_found_title": "まだ学習者がいません",
  "classroom_members_not_found_desc": "このクラスルームにはまだ学習者がいません。",
  "open_topic": "トピックを開く",
  "choose_game_mode": "ゲームモードを選択",
  "story": "ストーリー",
  "story_description": "キャラクター間の会話を聞き、理解度を測る質問に答えます。",
  "fill_in_blanks": "空欄埋め",
  "fill_in_blanks_description": "不足している部分を正しく特定できますか？",
  "fill_in_the_blanks": "空欄埋め",
  "fill_in_the_blanks_description": "不足している部分を正しく特定できますか？",
  "act_it_out": "演じる",
  "act_it_out_description": "正しい応答を選択できますか？",
  "act_it_out_listening": "演じる - リスニング",
  "act_it_out_listening_description": "リスニングスキルを使って正しい応答を選択。",
  "act_it_out_speaking": "演じる - スピーキング",
  "act_it_out_speaking_description": "あなたの役を話すことで発音を練習。",
  "act_it_out_listening_speaking": "演じる - リスニングとスピーキング",
  "act_it_out_listening_speaking_description": "あなたの役を話すことで発音を練習。",
  "select_role": "役割を選択",
  "select_role_description": "演じたい役割を選択してください。",
  "mute": "ミュート",
  "unmute": "ミュート解除",
  "replay": "再開",
  "restart": "再開",
  "click_to_speak": "クリックして話す",
  "click_to_stop": "クリックして停止",
  "listening_indicator": "聞いています...",
  "save_recording_to_report": "録音をレポートに保存",
  "no_voice_recording_saved": "音声録音が保存されませんでした",
  "classrooms_not_created": "クラスルームが作成されていません",
  "select_a_classroom": "クラスルームを選択",
  "voice_attempt": "音声試行",
  "upload_variables": "変数をアップロード",
  "next_game": "次のゲーム",
  "roleplay_games": "シナリオゲーム",
  "roleplay_games_description": "下記のカードの1つをクリックして特定のゲームをプレイ",
  "group_courses": "グループコース",
  "select": "選択",
  "classroom_creator_welcome": "クラスルームの開始",
  "classroom_creator_welcome_free_trial": "Nualangの30日間無料試用版へようこそ！開始するために最初のクラスルームをセットアップしました。",
  "classroom_creator_add_courses": "コースを追加",
  "classroom_creator_add_courses_desc": "クラスルームにコースを追加する方法を選択。",
  "classroom_creator_add_students_email": "学習者を招待",
  "classroom_creator_track_progress": "学習者の活動を追跡",
  "classroom_creator_track_progress_desc": "学習者がクラスルームに参加したら、追加されたコースでの進捗を表示するためクリック。",
  "forLang_and_learnLang_the_same": "学習言語と話者言語が同じです。その結果、翻訳課題は無効になります",
  "english": "英語",
  "french": "フランス語",
  "german": "ドイツ語",
  "irish": "アイルランド語",
  "italian": "イタリア語",
  "portuguese": "ポルトガル語",
  "spanish": "スペイン語",
  "close": "閉じる",
  "last": "最後",
  "update_avatar": "アバターを更新",
  "update_avatar_desc": "個人のアバターを更新",
  "invite_students": "学習者を招待",
  "share_student_link_desc": "学習者の参加を招待するために下記の指示を共有。",
  "invite_link_desc": "この招待リンクをクリックしてNualangでログインまたはアカウントを作成してください：",
  "join_instructions_1": "これによって以下に移動します ",
  "join_instructions_2": "あなたのために作成しました。そこで「参加」をクリックしてください",
  "enrollment_key_text": "そしてキーを入力： ",
  "copy_student_instructions": "学習者向け指示をコピー",
  "or_invite_via": "または以下で招待",
  "classroom": "クラスルーム",
  "invite_email_subject": "Nualangクラスルームへの参加招待",
  "dear_students": "学習者の皆さまへ",
  "dashboard": "ダッシュボード",
  "preview_roleplay": "シナリオをプレビュー",
  "roleplay_preview": "プレビュー",
  "roleplay_preview_decription": "完全なシナリオスクリプトをプレビュー",
  "sort": "並べ替え",
  "sort_by": "並べ替え順",
  "alphabetical": "アルファベット順",
  "recently_changed": "最近更新",
  "recently_viewed": "最近表示",
  "default": "デフォルト",
  "member": "学習者",
  "stop_speaking": "話すのを停止",
  "agree_to_terms_and_conditions_1": "私は",
  "nualang_terms": "Nualang利用規約",
  "agree_to_terms_and_conditions_2": "に同意します。これには私たちの",
  "privacy_policy": "プライバシーとデータ保護ポリシー",
  "first_classroom_description": "これは学習者が{{learnLang}}を自信を持って話すのを支援するクラスルームです。",
  "upload": "アップロード",
  "download": "ダウンロード",
  "classroom_creator_add_students_email_desc": "クラスルームに学習者を招待するさまざまな方法を探索するためクリック。",
  "bot_sign_in_message": "このチャットボットをプレイするにはログインが必要です",
  "course_sign_in_to_access": "このコースにアクセスするにはログインしてください",
  "have_an_account": "アカウントをお持ちですか？",
  "provide_a_little_more_information": "もう少し情報を提供してください",
  "instructions": "指示",
  "close_preview": "プレビューを閉じる",
  "check_recognition": "音声認識を確認",
  "checking_recognition": "音声認識を確認中...",
  "phrase_recognised": "フレーズが認識されました",
  "phrase_not_recognised": "フレーズが認識されませんでした",
  "speech_recognition_info": "音声認識をチェックすることで、学習者が私たちの課題でこのフレーズを発音するのに困難があるかどうかを判断できます。",
  "speech_recognition_error_info": "あなたのフレーズを{{recognisedPhrase}}として認識しました。フレーズを言い換えおよび/または代替版を追加することをお勧めします。",
  "my_library": "マイライブラリ",
  "add_own_exercise_message": "あなたが作成したテンプレートを使用して新しい{{exerciseName}}を作成",
  "no_exercises_in_library": "あなたが作成した{{exerciseName}}はありません。",
  "classroom_invite_feature_disabled_message": "学習者がこのクラスルームに自動的に参加できるため、この機能は無効です。",
  "skip_navigation": "ナビゲーションをスキップ",
  "generate_roleplay": "シナリオを生成",
  "choose_topic_for_roleplay": "シナリオのトピックを選択",
  "roleplay_generated": "シナリオが生成されました",
  "select_roleplay": "シナリオを選択",
  "chatgpt_roleplay_description": "これは{{topic}}についてのシナリオです",
  "check_answer": "答えを確認",
  "card": "カード",
  "banner": "バナー",
  "load_more": "さらに読み込む",
  "bot_input_placeholder": "キーボードを使ってメッセージを入力",
  "bot_input_mobile_placeholder": "メッセージを入力...",
  "audio_only_mode": "聞いて話す",
  "audio_only_tooltip": "音声のみモードに切り替える",
  "switch_to_text": "テキストに切り替える",
  "switch_to_text_tooltip": "テキストモードに戻る",
  "audio_only_title": "{{botName}}と話す",
  "audio_only_subtitle": "完全に音声だけの会話です — テキストはありません。ヘッドホンの使用をおすすめします。",
  "audio_only_mode_unavailable_fallback_chat": "この演習には「聞く・話す」モードが必要ですが、このデバイスでは利用できません。代わりにチャットモードで続行します。",
  "microphone_ready": "マイクの準備ができました",
  "bot_is_speaking": "話しています...",
  "thinking_indicator": "考え中...",
  "start_conversation": "会話を始める",
  "stop_button_label": "停止",
  "stop_bot_message": "チャットボットの音声を停止",
  "choose_mode_text_option": "チャット",
  "choose_mode_text_option_desc": "答えを入力または話して、ボットの返信を読んだり聞いたりできます。",
  "bot_mode_in_progress_icon": "{{mode_name}}の会話が現在進行中",
  "bot_mode_completed_icon": "{{mode_name}}が{{counter}}回完了しました",
  "bot_modes_completed_icon": "{{mode_name}}が{{counter}}回完了しました",
  "replay_button_label": "再生",
  "replay_bot_message": "チャットボットのメッセージを繰り返す",
  "you": "あなた",
  "ready_when_you_are": "準備ができたら始めましょう",
  "bot_speaking_banner": "{{botName}}が話しています",
  "listening_to_you": "聞いています",
  "bot_thinking_banner": "{{botName}}が考えています",
  "one_moment": "少々お待ちください",
  "listen_first": "まず聞いてください",
  "tap_when_done": "終わったらタップしてください",
  "conversation_complete": "会話が完了しました",
  "exchanges_label": "やり取り",
  "time_spoken_label": "話した時間",
  "review_your_turns": "自分の発言を確認する",
  "submit_to_teacher": "先生に提出する",
  "great_job": "よくできました！",
  "or": "または",
  "choose_difficulty_of_roleplay": "シナリオの難易度を選択",
  "child": "子ども",
  "game_visibility": "ゲーム表示設定",
  "duplicate_course": "コースを複製",
  "amount_must_not_exceed_10": "数量は10を超えてはいけません",
  "amount_must_be_greater_than_0": "数量は0より大きくなければなりません",
  "voice_pitch": "音声ピッチ",
  "voice_pitch_example": "こんにちは、私の名前は{{name}}です",
  "voice_pitch_disabled": "この音声ではピッチの調整はできません。",
  "voice_pitch_x_low": "とても低い",
  "voice_pitch_low": "低い",
  "voice_pitch_medium": "中程度",
  "voice_pitch_high": "高い",
  "voice_pitch_x_high": "とても高い",
  "contact_us": "お問い合わせ",
  "contact_us_message": "Nualangをご利用いただき、ありがとうございます。下記にメッセージをお送りください。できるだけ早くご返答いたします。",
  "expected_phrases": "期待されるフレーズ",
  "expected_phrases_info": "学習者が課題中に使用すると予想され、学習者が話すときに正しく認識されたいフレーズ。例えば、課題が天気についての場合、'whether'より'weather'をより頻繁に認識したいかもしれません",
  "add_expected_phrases": "期待されるフレーズを追加",
  "phrase_length_exceeded_error": "フレーズは100文字を超えてはいけません",
  "whats_new": "新着情報",
  "wayside_subscription_message": "あなたのサブスクリプションはWayside Publishingによって管理されています",
  "select_the_correct_answer": "正しい答えを選択",
  "pronunciation_score": "発音スコア",
  "pronunciation_score_explanation": "発音スコアは正しく認識された単語数（{{transcriptCompletenessPercentage}}%）とそれらがどれだけ明瞭に認識されたかに基づいています。",
  "add_course": "コースを追加",
  "generate_roleplay_existing_script_confirmation": "既存のスクリプトを置き換えてもよろしいですか？",
  "experimental_feature_desc": "新しいAI機能 - あなたのフィードバックをお聞かせください",
  "generating_roleplay": "シナリオを生成中",
  "updated": "更新されました",
  "exercise_completed": "課題完了",
  "exercise_not_completed": "課題未完了",
  "view_topic": "トピックを表示",
  "view_roleplay": "シナリオを表示",
  "view_bot": "チャットボットを表示",
  "student_reports_problem": "学習者が課題中に問題を報告",
  "problem_reported": "問題が報告されました",
  "remove_course_confirmation": "このコースを削除してもよろしいですか？",
  "classroom_member_limit_reached": "クラスルームが学習者数上限に達しました",
  "upload_pdf": "PDFをアップロード",
  "remove_pdf": "PDFを削除",
  "classroom_updated": "クラスルームが更新されました",
  "deleted": "削除されました",
  "created": "作成されました",
  "moderation_warning": "アップロードした画像で以下のカテゴリが検出されました： ",
  "warning": "警告",
  "use_anyways": "それでも使用",
  "view_pdf": "ストーリーを表示",
  "schedule_discussion": "ディスカッションをスケジュール",
  "video_chat": "ビデオチャット",
  "video_chat_member": "ビデオチャットメンバー",
  "create_meeting": "ミーティングを作成",
  "group_assignment": "グループ課題",
  "join_group": "グループに参加",
  "groups": "グループ",
  "group": "グループ",
  "welcome": "ようこそ",
  "delete_pdf": "PDFを削除",
  "delete_pdf_confirmation": "このPDFを削除してもよろしいですか？",
  "course_updated": "コースが更新されました",
  "overwrite_phrases": "フレーズを上書き",
  "roleplay_game_in_progress_icon": "シナリオゲームが現在進行中",
  "roleplay_game_completed_icon": "シナリオゲームが{{counter}}回完了しました",
  "roleplay_games_completed_icon": "シナリオゲームが{{counter}}回完了しました",
  "page": "ページ",
  "remove_group": "グループを削除",
  "create_groups": "グループを作成",
  "select_all": "すべて選択",
  "unknown": "不明",
  "add_a_discussion_topic": "ディスカッショントピックを追加",
  "add_a_discussion_prompt": "ディスカッションプロンプトを追加",
  "add_a_url_for_students_to_discuss": "学習者がディスカッションするためのURLを追加",
  "images_that_students_can_use_as_a_background_during_the_call": "学習者が通話中に背景として使用できる画像",
  "discussion_images": "ディスカッション画像",
  "images_for_students_to_discuss_during_the_call": "学習者が通話中にディスカッションする画像",
  "recording_time": "録画時間",
  "due_date": "締切日",
  "record_time_limit": "録画時間制限",
  "interculturality": "異文化性",
  "comprehensibility": "理解度",
  "function_and_text_type": "機能とテキストタイプ",
  "vocabulary_in_context": "文脈での語彙",
  "Drag_and_drop_image_from_your_computer": "コンピューターから画像をドラッグ&ドロップ",
  "schedule_discussion_options": "ファイルサイズ超過",
  "chat_options": "チャットオプション",
  "recording_info": "提出情報",
  "discussion_id": "ディスカッションID",
  "discussion_prompt": "ディスカッションプロンプト",
  "attendees": "参加者",
  "created_discussions": "作成されたディスカッション",
  "grouped_discussions": "グループディスカッション",
  "no_recordings_found": "録画が見つかりません",
  "recordings": "録画",
  "scheduled_meetings": "スケジュールされたミーティング",
  "no_meetings_scheduled": "スケジュールされたミーティングなし",
  "discussion_info": "ディスカッション情報",
  "invites": "招待",
  "invited_members": "招待された学習者",
  "minute": "分",
  "feedback": "フィードバック",
  "view": "表示",
  "no_data_found": "データが見つかりません",
  "no_past_discussions_found": "過去のディスカッションが見つかりません",
  "no_submissions_found": "提出が見つかりません",
  "background_images": "背景画像",
  "no_scheduled_discussions_found": "スケジュールされたディスカッションが見つかりません",
  "view_more": "さらに表示",
  "past": "過去",
  "submissions": "提出",
  "join_live_game": "ライブゲームに参加",
  "live_game_medals": "ライブゲームメダル",
  "live_game_medals_description": "ライブゲームで1位、2位、3位に入賞してメダルをアンロックしよう",
  "classroom_has_no_live_game": "クラスルームには現在ライブゲームがありません",
  "speech_recognition_error_info_no_phrase": "あなたのフレーズを認識できませんでした。フレーズを言い換えおよび/または代替版を追加することをお勧めします。",
  "no_conversation_available": "利用可能な会話なし",
  "no_special_characters": "特殊文字は含めることができません",
  "required": "必須",
  "enrolment_key_min_chars": "登録キーは最低5文字以上である必要があります",
  "zoom_in": "ズームイン",
  "zoom_out": "ズームアウト",
  "game_created": "ゲームが作成されました",
  "nuala_performance_rating": "ヌアラパフォーマンス評価",
  "using_nuala_performance": "ヌアラパフォーマンス評価を使用すると、手動で作成された評価が失われます。",
  "are_you_sure_nuala_performance": "ヌアラパフォーマンス評価を使用してもよろしいですか？",
  "play_live": "ライブプレイ",
  "play_live_desc": "クラスルームでライブプレイしたい課題を選択。",
  "live_dialog_description": "クラスルームでライブプレイしたい課題を選択。",
  "course_deletion_note": "*注意：このコースを削除すると、このコースの{{sectionCount}}セクションとその内容も削除されます",
  "classroom_deletion_note": "*注意：このクラスルームを削除すると、このクラスルームの{{courseCount}}コースとその内容も削除されます",
  "topic_deletion_note": "*注意：このトピックを削除すると、このトピックの{{phraseCount}}フレーズ、{{botCount}}チャットボット、{{roleplayCount}}シナリオとその内容も削除されます",
  "section_deletion_note": "*注意：このセクションを削除すると、このセクションの{{topicCount}}トピックとその内容も削除されます",
  "confirmDeletionText": "削除を確認するには、下記のフィールドに「delete」と入力してください",
  "subscription_status_cancelled": "キャンセル済み",
  "subscription_status_active expired": "期限切れ",
  "subscription_status_active_expired": "期限切れ",
  "leaderboard": "リーダーボード",
  "waiting_message": "準備してください、ゲームが間もなく開始します",
  "play_game": "ゲームをプレイ",
  "close_game": "ゲームを閉じる",
  "cancel_game": "ゲームをキャンセル",
  "end_game": "ゲーム終了",
  "games": "ゲーム",
  "course_no_sections": "このコースにはセクションがありません",
  "topic_no_phrases": "このトピックにはフレーズがありません",
  "next_question": "次の質問",
  "your_answer": "あなたの回答",
  "change_answer": "回答を変更",
  "final_results": "結果",
  "game_ended": "ゲーム終了",
  "joined_game": "ゲームに参加",
  "equipment_problem_label": "機器の問題",
  "equipment_problem_example": "例：スピーカーやマイクが動作しない",
  "technical_problem_label": "技術的問題",
  "technical_problem_example": "例：アプリが正しく動作しない",
  "content_problem_label": "コンテンツの問題",
  "content_problem_example": "例：課題コンテンツに間違いを発見した",
  "end_question_early": "質問を早期終了",
  "discussion_topic": "ディスカッショントピック",
  "discussion_link": "ディスカッションリンク",
  "scheduled": "スケジュール済み",
  "timer_length": "タイマー長さ",
  "go_back_to_classroom": "クラスルームに戻る",
  "discussion_created": "ディスカッションが作成されました",
  "discussion_updated": "ディスカッションが更新されました",
  "give_feedback": "フィードバックを提供",
  "nualang_live_welcome": "Nualang Liveへようこそ！",
  "nualang_live_invite": "学習者を招待",
  "nualang_live_invite_desc": "学習者がゲームに参加する方法を確認するにはここをクリック。",
  "nualang_live_game_members": "ゲームメンバー",
  "nualang_live_game_members_desc": "まだゲームに参加していない人を確認するにはここをクリック。",
  "nualang_live_start_game": "ゲームを開始！",
  "nualang_live_settings": "ゲーム設定",
  "nualang_live_settings_desc": "ゲームオプションを確認するにはここをクリック",
  "keyboard_and_word_bank": "キーボードと単語バンク",
  "keyboard_only": "キーボードのみ",
  "word_bank_only": "単語バンクのみ",
  "answer_options": "回答オプション",
  "game_settings": "ゲーム設定",
  "create_feedback": "フィードバックを作成",
  "first_place": "1位",
  "second_place": "2位",
  "third_place": "3位",
  "final_score": "最終スコア",
  "no_discussions_found": "ディスカッションが見つかりません",
  "no_discussions_found_desc": "すべてのディスカッションと提出はここで確認できます",
  "quality_of_interaction": "相互作用の質",
  "number_of_questions": "質問数",
  "estimated_game_time": "推定ゲーム時間",
  "minutes": "分",
  "discuss": "ディスカッション",
  "open_live_game": "ライブゲームを開く",
  "correct_answers": "正答",
  "game_has_ended": "このゲームは終了しました。新しいライブゲームをお待ちください。",
  "game_has_canceled": "このゲームはキャンセルされました。新しいライブゲームをお待ちください。",
  "allow_wordBank": "学習者が課題で単語バンクを使用することを許可",
  "creator_default": "作成者のデフォルト",
  "course_default": "コースデフォルト",
  "course_settings_description": "このクラスルームの学習者の学習体験を調整",
  "change_settings": "設定を変更",
  "choose_topic_from_pdf_for_roleplay": "コースPDFのコンテキストに基づいてシナリオのトピックを選択",
  "use_context_from_course_pdf": "コースPDFのコンテキストを使用",
  "use_context_from_course_pdf_info": "プロンプトがPDF内のコンテンツに関連している場合、コースPDFのコンテンツに基づいてシナリオを生成できるようにするには、これをオンにしてください",
  "feedback_all_info": "ディスカッショングループのすべての学習者にフィードバックを提供します。学習者にグループと個人の両方のフィードバックを提供することはできません。",
  "rubric_info_desc": "分析的成長ルーブリック、AIフィードバックで使用されている基準をご覧ください。",
  "rubric_info": "ルーブリック情報",
  "listen_to_story": "ストーリーを聞く",
  "roleplay_no_interactions": "このシナリオには相互作用がありません",
  "number_of_interactions": "相互作用数",
  "archive_title_submissions": "提出をアーカイブ",
  "archive_description_submissions": "提出をアーカイブしてもよろしいですか？",
  "archive_title": "ディスカッションをアーカイブ",
  "archive_description": "このディスカッションをアーカイブしてもよろしいですか？このディスカッションへの学習者の招待も削除されます。",
  "discussion_templates": "ディスカッションテンプレート",
  "discussion_templates_desc": "学習者向けのコンテンツ作成を支援する事前定義されたディスカッションテンプレートのいずれかを使用",
  "find_courses": "コースを検索",
  "create_your_own": "独自に作成 ",
  "community_courses_description": "学習者向けにライブラリからコースを見つけます",
  "create_your_own_description": "学習者向けに全く新しいコースを構築",
  "empty_live_dialog_description": "クラスルームでライブプレイしたい場合はコースを追加してください。",
  "no_classroom_to_join": "あなたの教師はまだNualangでクラスルームをセットアップしていません。セットアップするよう依頼してから、再度お試しください。",
  "resume": "再開",
  "pause": "一時停止",
  "discuss_welcome": "ディスカッションガイド",
  "discuss_scheduled_discussions": "スケジュールされたディスカッション",
  "discuss_scheduled_discussions_desc": "これは教師が作成したスケジュールされたディスカッションが見つかる場所です。これらのディスカッションに参加し、グループ内の他の学習者とトピックについて話すことができます。",
  "discuss_refresh_discussions": "ディスカッションを更新",
  "discuss_refresh_discussions_desc": "このボタンで最新のディスカッションデータを取得するために更新できます。",
  "discuss_recorded_discussions": "録画ディスカッション",
  "discuss_recorded_discussions_desc": "ここでは録画して教師のレビュー用に提出したディスカッションを見つけることができます。フィードバックが提供されると、それを表示できます。",
  "discuss_grouped_discussions": "グループディスカッション",
  "discuss_grouped_discussions_desc": "ここではトピック名に基づいて学習者向けに作成したすべてのディスカッションを見つけることができます。グループディスカッションをクリックして、どの学習者グループが作成されたかを確認してください。",
  "discuss_submissions": "ディスカッション提出",
  "discuss_submissions_desc": "ここでは学習者グループが作成した録画ディスカッション提出を見つけることができます。録画とディスカッションのトランスクリプトを表示し、個人またはグループのフィードバックを提供できます。",
  "refresh_discuss": "ディスカッションを更新",
  "nuala_ai": "ヌアラAI",
  "performance_ratings": "パフォーマンス評価",
  "attended": "出席",
  "did_not_attend": "出席せず",
  "discussion_attendance": "ディスカッション出席",
  "submitted_recordings": "提出された録画",
  "invalid_date": "無効な日付",
  "go_to_profile_settings": "プロフィール設定に移動",
  "not_applicable": "省略",
  "comprehension": "理解度",
  "feedback_text": "フィードバックテキスト",
  "submit_feedback": "フィードバックを提出",
  "select_students_to_group": "すべての学習者を選択",
  "created_groups": "作成されたグループ",
  "feedback_info": "フィードバック情報",
  "sample_discussion_ideas": "ディスカッションアイデアのサンプル",
  "image_library": "画像ライブラリ",
  "upload_video": "動画をアップロード",
  "select_video_desc": "コンピューターから動画をドラッグ&ドロップ",
  "add_video": "動画を追加",
  "play_video": "動画を再生",
  "video_info": "コース動画",
  "delete_video": "動画を削除",
  "delete_video_confirmation": "この動画を削除してもよろしいですか？",
  "view_video": "動画を表示",
  "video_options": "動画オプション",
  "congratulations": "おめでとうございます！",
  "medal_has_been_added_to_your_profile": "メダルがプロフィールに追加されました",
  "pdf_options": "PDFオプション",
  "disable_keyboard": "キーボードを無効化",
  "enable_keyboard": "キーボードを有効化",
  "view_story": "ストーリーを表示",
  "view_question": "質問を表示",
  "save_library": "ライブラリに保存",
  "minimum_two_phrases": "この課題にはトピック内に最低2つのフレーズが必要です。",
  "roleplay_not_valid": "この課題には最低1つの相互作用と1つの質問が必要です。",
  "move_topic": "トピックを移動",
  "move_section": "セクションを移動",
  "move_roleplay": "シナリオを移動",
  "duplicate_roleplay": "シナリオを複製",
  "leave_game": "ゲームを退出",
  "leave_game_confirmation": "このゲームを退出してもよろしいですか？",
  "leave": "退出",
  "explore": "探索",
  "listen": "聞く",
  "download_template": "テンプレートをダウンロード",
  "member_activity": "学習者の活動",
  "move_phrase": "フレーズを移動",
  "multiple_choice": "多択式",
  "record": "録音",
  "nualang_live_help": "プレイ方法",
  "nualang_live_help_desc": "ゲームのプレイ方法を確認するにはここをクリック",
  "roleplay-story": "ストーリー",
  "teach_classrooms_desc": "ダイナミックな学習環境で学習者を管理し、相互作用します",
  "teach_classrooms_title": "クラスルームを魅力的に",
  "teach_courses_desc": "完全な学習体験を提供するためにカリキュラムを設計し、構造化します",
  "teach_courses_title": "包括的なコースを構築",
  "teach_roleplays_title": "新しい種類のシナリオ",
  "teach_roleplays_desc": "シナリオを使った指導により、学習者がスクリプト化された会話に参加し、言語スキルを練習するダイナミックで没入型の方法を提供します",
  "teach_bots_title": "チャットボットでの創造性",
  "teach_bots_desc": "チャットボットを使った指導は、学習者が実際の会話のようにシームレスに流れる自然な会話スタイルと自信を身に付けるのに役立ちます",
  "learn_bots_title": "チャットボットでの創造性",
  "learn_bots_desc": "チャットボットを使った学習により、実際の会話のようにシームレスに流れる自然で魅力的な会話スタイルを身に付けることができます",
  "learn_roleplays_title": "新しい種類のシナリオ",
  "learn_roleplays_desc": "シナリオを使った学習により、スクリプト化された会話に参加し、言語スキルを練習するダイナミックで没入型の方法を提供します",
  "learn_classrooms_desc": "ダイナミックな学習環境で同級生や教師と相互作用できるクラスルームに参加",
  "learn_classrooms_title": "インタラクティブな学習スペース",
  "learn_courses_desc": "構造化されたレッスンと活動による完全な学習体験を提供するよう設計されたコースに登録",
  "learn_courses_title": "包括的な学習パス",
  "video_included": "動画",
  "story_included": "ストーリー",
  "answer_helper_text": "Enter/リターンキーを押して回答を追加。",
  "move_answer": "回答を移動",
  "remove_answer": "回答を削除",
  "remove_question": "質問を削除",
  "supported_file_types": "サポートされているファイル形式：mp4、mov",
  "exercise_description": "このフレーズを聞いてください",
  "translate_description": "最多ポイントを獲得するために可能な限り早くフレーズを翻訳してください！",
  "result_description": "他のみんなと比較してあなたの順位を確認してください！",
  "listening_description": "最多ポイントを獲得するために可能な限り早く答えを選択してください！",
  "roleplay_intro": "2人のキャラクター間の会話を聞いてください！",
  "topic_no_roleplays": "このトピックにはシナリオがありません。",
  "case_sensitive": "これは大文字小文字の区別のためマークされました",
  "required_field": "*でマークされたフィールドは必須です",
  "close_drawer": "ドロワーを閉じる",
  "generate_question": "質問を生成",
  "generating_question": "質問を生成中",
  "experimental_feature_desc_answer": "「質問を生成」ボタンは新しいAI機能です - あなたのフィードバックをお聞かせください",
  "question_type": "質問タイプ",
  "multiple_choice_factual": "多択式 - 事実",
  "multiple_choice_inference": "多択式 - 推論",
  "vocabulary": "語彙",
  "true_false": "正誤問題",
  "insert_emoji": "絵文字を挿入",
  "moderation_reason": "画像は以下の内容のためブロックされました：{{moderationReason}}",
  "move_bot": "チャットボットを移動",
  "duplicate_bot": "チャットボットを複製",
  "discuss_description": "ディスカッションはライブでインタラクティブな会話のためのプラットフォームです。プロンプトに基づいて魅力的なディスカッションを作成するか、提案されたトピックから選択してください。学習者がリアルタイムで協力し、アイデアを共有する様子をご覧ください。",
  "enable_discuss": "設定でディスカッションを有効化",
  "incomplete_translation": "この文にはまだ続きがあります！",
  "experimental_feature_desc_phrases": "「フレーズを生成」ボタンは新しいAI機能です - あなたのフィードバックをお聞かせください",
  "choose_topic_for_phrases": "フレーズのトピックを何にしますか？",
  "how_many_phrases": "フレーズ数：{{phraseAmount}}",
  "generate_phrases": "フレーズを生成",
  "generating_phrases": "フレーズを生成中",
  "duplicate_answer_desc": "質問に重複した回答を含めることはできません",
  "question_language": "質問と回答の言語を選択",
  "generate_questions": "質問を生成",
  "enable_gen_questions": "シナリオに関連する理解度確認質問を生成するには、これを有効にしてください。",
  "use_topic_phrases": "トピックフレーズを使用",
  "enable_phrase_context": "シナリオ生成時にトピックのフレーズをコンテキストとして使用するには、これを有効にしてください。",
  "add_phrase_context": "この機能を有効にするには、トピックにフレーズを追加してください。",
  "enter_phrase_with_alternatives": "代替案を含むフレーズを入力",
  "sentences": "文",
  "words": "単語",
  "phrase_type": "フレーズタイプ",
  "archive_classroom": "クラスルームをアーカイブ",
  "archive_classroom_confirmation": "このクラスルームをアーカイブしてもよろしいですか？",
  "unarchive_classroom": "クラスルームのアーカイブを解除",
  "unarchive_classroom_confirmation": "このクラスルームのアーカイブを解除してもよろしいですか？",
  "confirmArchiveText": "アーカイブを確認するには、下記のフィールドに「archive」と入力してください",
  "confirmUnarchiveText": "アーカイブ解除を確認するには、下記のフィールドに「unarchive」と入力してください",
  "generate_bot": "チャットボットを生成",
  "generating_bot": "チャットボットを生成中",
  "choose_topic_for_bot": "このチャットボットのトピックを何にしますか？",
  "use_context_from_topic_phrases": "トピックフレーズを使用",
  "generate_bot_existing_script_confirmation": "既存のスクリプトを置き換えてもよろしいですか？",
  "voice_speed": "音声速度",
  "phrase_to_speak": "話すフレーズ",
  "voice_speed_extra_slow": "超遅",
  "voice_speed_slow": "遅",
  "voice_speed_medium": "中",
  "voice_speed_fast": "速",
  "voice_speed_extra_fast": "超速",
  "play_audio": "音声を再生",
  "generate_audio": "音声を生成",
  "topic_goal": "コミュニケーション目標",
  "topic_goal_info_text": "このレッスンの終わりに学習者ができるようになってほしいことは何ですか？",
  "archived_classrooms_title": "アーカイブされたクラスルームなし",
  "archived_classrooms_desc": "クラスルームが完了したら、アーカイブできます。これにより、すべての学習者と協力者にとってクラスルームがアーカイブされます。",
  "bot_created": "チャットボットが作成されました",
  "bot_deleted": "チャットボットが削除されました",
  "ukrainian": "ウクライナ語",
  "arabic": "アラビア語",
  "chinese_simplified": "中国語（簡体字）",
  "chinese_traditional": "中国語（繁体字）",
  "czech": "チェコ語",
  "danish": "デンマーク語",
  "dutch": "オランダ語",
  "filipino": "フィリピン語",
  "greek": "ギリシャ語",
  "hindi": "ヒンディー語",
  "hungarian": "ハンガリー語",
  "indonesian": "インドネシア語",
  "japanese": "日本語",
  "korean": "韓国語",
  "malay": "マレー語",
  "polish": "ポーランド語",
  "punjabi": "パンジャブ語",
  "romanian": "ルーマニア語",
  "swahili": "スワヒリ語",
  "thai": "タイ語",
  "turkish": "トルコ語",
  "vietnamese": "ベトナム語",
  "speak_disabled": "話すが無効です",
  "move_message": "メッセージを移動",
  "move_question": "質問を移動",
  "topic_goal_placeholder": "例：私は自分のアイデンティティについて質問したり答えたりできます。",
  "download_csv_template": "CSVテンプレートをダウンロード",
  "upload_csv": "CSVをアップロード",
  "remove_csv": "CSVを削除",
  "single_phrase": "単一フレーズ",
  "list_of_phrases": "フレーズリスト",
  "text_studio": "テキスト読み上げスタジオ",
  "text_studio_description": "ヌアラがテキストを音声に変換するお手伝いをします。言語を選択し、厳選された音声から選んでテキストに命を吹き込んでください。",
  "no_phrases_yet": "まだフレーズがありません...",
  "access_denied_domain_unverified": "アクセス拒否：ドメインが未確認",
  "file_name": "ファイル名",
  "download_audio": "音声をダウンロード",
  "no_answer": "回答なし",
  "left_group": "グループを退出",
  "view_feedback": "フィードバックを表示",
  "no_feedback": "この学習者にはまだフィードバックを提供していません",
  "app_search_placeholder": "コミュニティのコンテンツを検索",
  "delete_phrases": "フレーズを削除",
  "delete_phrases_confirmation": "選択したフレーズを削除してもよろしいですか？",
  "share_audio": "音声をNualangと共有したくない場合は、このボックスのチェックを外してください。音声を共有すると、問題の診断に役立ちます。",
  "edit_phrase": "フレーズを編集",
  "share_screenshot": "スクリーンショットをNualangと共有したい場合は、このボックスにチェックを入れてください。スクリーンショットを共有すると、問題の診断に役立ちます。",
  "screenshot_captured": "スクリーンショットがキャプチャされました：",
  "classroom_creator_play_live_game": "Nualang LIVEをプレイ",
  "classroom_creator_play_live_game_desc": "Nualang LIVEはカスタマイズ可能なゲームを提供し、学習者にとってダイナミックで魅力的な環境を作成し、スキルをテストし、お互いに競争して待望のヌアラメダルを獲得できるようにします。",
  "search_error": "検索中にエラーが発生しました。もう一度試してください",
  "create_feedback_error": "フィードバック作成中にエラーが発生しました。もう一度試してください",
  "get_recs_error": "録画取得中にエラーが発生しました",
  "get_image_error": "画像取得中にエラーが発生しました",
  "update_discussion_error": "ディスカッション更新中にエラーが発生しました。もう一度試してください",
  "invite_users_error": "ユーザー招待中にエラーが発生しました。もう一度試してください",
  "create_image_error": "画像アップロード中にエラーが発生しました。もう一度試してください",
  "grade_conversation_error": "会話評価中にエラーが発生しました。もう一度試してください",
  "get_transcript_error": "トランスクリプト取得中にエラーが発生しました。もう一度試してください",
  "get_subs_error": "提出取得中にエラーが発生しました。もう一度試してください",
  "delete_picture_confirmation": "この画像を削除してもよろしいですか？",
  "inappropriate_language_detected": "不適切な言語が検出されました",
  "schedule_discussion_error": "ディスカッションのスケジュール中にエラーが発生しました。もう一度試してください",
  "heritage_speaker": "読み書き",
  "unmark_as_heritage_speaker": "読み書きモードを無効化",
  "mark_as_heritage_speaker": "読み書きモードを有効化",
  "heritage_speaker_desc": "適切な箇所でリスニングとスピーキングを無効にし、読み書きに焦点を当てます。継承学習者を念頭に設計されています。",
  "heritage_speaker_point_1": "単語バンクは無効になります",
  "heritage_speaker_point_2": "適切な箇所でリスニングと発音が無効になります。",
  "freely_changed": "これはいつでも自由に変更できます。",
  "mark_as_challenge_student": "チャレンジモードを有効化",
  "unmark_as_challenge_student": "チャレンジモードを無効化",
  "mark_as_challenge_bot": "チャレンジモードとしてマーク",
  "unmark_as_challenge_bot": "チャレンジモードのマークを解除",
  "challenge_student": "チャレンジモード",
  "challenge_student_desc": "長い返答や正式で学術的な言語を促すチャットボットをロック解除します。継承学習者を念頭に設計されています。",
  "challenge_bot": "チャレンジモード",
  "challenge_bot_desc": "このチャットボットは学習者タブでチャレンジモードが有効になった学習者のみに表示されます。継承学習者を念頭に設計されており、正式で学術的なプロンプトを提供します。",
  "rewatch_tutorial": "チュートリアルを再視聴",
  "heritage_speaker_progress": "「読み書き」としてマークされた学習者は、読み書きにより焦点を当てるように学習体験が調整されます。",
  "generate_transcript": "トランスクリプトを生成",
  "suggested_images": "提案された画像",
  "word_near_correct": "この単語は正しいですが、位置が間違っています",
  "partially_correct": "部分的に正解",
  "tag_info": "タグはコンテンツの整理と分類に役立ち、関連資料の検索とグループ化を容易にします。タグを使用してコンテンツの発見可能性を向上させ、ワークフローを合理化してください。",
  "assignments": "課題",
  "assign_exercises": "課題を割り当て",
  "assign_exercises_desc": "厳選されたコンテンツライブラリから活動を選択し、数回のクリックで学習者に課題を割り当てます。学習を強化し、スキルを練習し、理解を深めるよう設計された課題に取り組む様子をご覧ください。",
  "assign_discuss": "ディスカッションを割り当て",
  "assign_discuss_desc": "ディスカッションはライブでインタラクティブな会話のためのプラットフォームです。プロンプトに基づいて魅力的なディスカッションを作成するか、提案されたトピックから選択してください。学習者がリアルタイムで協力し、アイデアを共有する様子をご覧ください。",
  "archive_discussions": "アーカイブされたディスカッション",
  "archive_submissions": "アーカイブされた提出",
  "assignment": "課題",
  "create_assignment": "課題を作成",
  "no_assignments": "課題なし",
  "assignments_description": "課題はインタラクティブなコンテンツで学習者を魅了する素晴らしい方法です。学習を強化し、スキルを練習し、理解を深めるために課題を作成してください。",
  "no_assignments_desc": "このクラスルームにはまだ課題がありません。",
  "select_classroom": "クラスルームを選択",
  "assignment_title": "課題タイトル",
  "assignment_description": "課題説明",
  "select_members": "学習者を選択",
  "schedule_assignment": "課題をスケジュール",
  "assign_date": "利用開始日",
  "add_exercise": "課題を追加",
  "add_exercises": "課題を追加",
  "assign_exercises_description": "学習者に割り当てるためにライブラリから課題を選択",
  "due_in": "提出まで",
  "due_tomorrow": "明日締切",
  "student_edited_transcript": "学習者が録画後にこのトランスクリプトを手動で編集しました。",
  "member_updated": "学習者が更新されました",
  "delete_assignment": "課題を削除",
  "delete_assignment_confirmation": "この課題を削除してもよろしいですか？",
  "assignment_deleted": "課題が削除されました",
  "assignment_created": "課題が作成されました",
  "assignees_created": "割り当て先が作成されました",
  "classroom_creator_subscription_expired": "作成者のサブスクリプションが期限切れです。",
  "return_to_classrooms": "クラスルームに戻る",
  "creator_not_subscribed_upgrade_title": "サブスクリプション期限切れ",
  "creator_not_subscribed_upgrade": "あなたのサブスクリプションが期限切れです。以下の機能を継続するにはプランをアップグレードしてください：",
  "creator_not_subscribed_upgrade_description": "クラスルーム活動への学習者アクセス。",
  "creator_not_subscribed_upgrade_description2": "Nualang LIVEゲーム作成機能",
  "creator_not_subscribed_upgrade_description3": "学習者のクラスルーム参加機能。",
  "due_today": "今日締切",
  "update_assignment": "課題を更新",
  "refresh_assignments": "課題を更新",
  "report_type": "タイプ",
  "go_back_to_assignments": "課題に戻る",
  "available_today": "今日利用可能",
  "available_tomorrow": "明日利用可能",
  "available_in": "利用可能まで",
  "not_assigned": "未割り当て",
  "assigned": "割り当て済み",
  "view_assignment": "課題を表示",
  "no_assignments_description": "現在作成された課題はありません。",
  "no_shared_courses": "選択されたクラスルーム間に共有コースがありません。",
  "view_submissions": "提出を表示",
  "archive": "アーカイブ",
  "generated_phrases": "以下の生成されたフレーズをリストに追加してもよろしいですか？これらのフレーズは追加され、既存のフレーズは置き換えられません。",
  "everyone": "全員",
  "discussions": "ディスカッション",
  "duplicate_course_confirmation": "これにより編集可能なコースのコピーが作成されます。元のコースからの更新や変更は受信されません。",
  "duplication": "他の人がこのコースを複製することを許可する。",
  "invalid_email_format": "無効なメール形式",
  "email_domain_mismatch_error": "メールはあなたのドメイン（{{domain}}）からのものである必要があります。",
  "generic_email_domain_error": "一般的なメールドメインエラー",
  "duplicate_disabled_tooltip": "このコースは作成者により複製が無効にされています。",
  "collaborators_only": "協力者のみ",
  "assign_to": "割り当て先",
  "all_students": "全学習者",
  "default_assignment_title": "新しいクラスルーム課題",
  "default_assignment_instructions": "締切日までに以下のタスクを完了してください。",
  "due": "締切",
  "hide_course": "コースを隠す",
  "show_course": "コースを表示",
  "hello": "こんにちは",
  "dynamic_response": "動的返答",
  "dynamic_response_desc": "このクラスルームのチャットボットが学習者の入力に基づいてAIを活用したカスタマイズされた返答を生成することを許可します。",
  "ai_chatbot_message_info": "このチャットボットメッセージはAIを使って生成されています。",
  "ai_chatbot_message_generating_info": "このチャットボットメッセージはAIを使って生成中です。",
  "language_correction": "言語の訂正",
  "correction_original": "元の文",
  "correction_suggested": "提案",
  "language_corrections_to_review": "復習する言語の訂正",
  "dynamic_responses_info": "この機能を有効にすると、チャットボットがAIを使用して学習者の発言に基づいて個人化された返答を生成できるようになります。これはより魅力的な学習をサポートできますが、返答は自動生成され、変動する可能性があります。すべてのAI使用は安全で責任ある説明可能な学習を確保するための明確で信頼できる基準に従っています。",
  "paste_your_csv_data": "ここにCSVデータを貼り付け",
  "user_level_settings": "ユーザーレベル設定",
  "chatbot_dynamic_responses": "Chatbot - Dynamic Responses",
  "chatbot_dynamic_responses_desc": "If dynamic response is turned on, the Chatbots will actively listen and adapt, prompting for more detail, clearer phrasing, or realistic answers, instead of just moving to the next scripted prompt.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "下記のトランスクリプトにはあなたのレビューが必要です。",
  "challenge_mode": "チャレンジモード",
  "student_misuse_reported": "学習者の誤用が報告されました",
  "student_acts_inappropriately": "学習者がチャットボット課題中に不適切に行動",
  "ai_chatbot_error_response": "申し訳ありませんが、私の返答に間違いがありました。もう一度試してください！",
  "no_members_tooltip": "このクラスルームに学習者やコースがないため、このアクションを実行できません。",
  "overdue": "期限切れ",
  "due_next": "次の締切",
  "active": "アクティブ",
  "archived": "アーカイブ済み",
  "past_due": "期限超過",
  "available_from": "利用開始",
  "roleplay-fill-in-the-blanks": "シナリオ空欄埋め",
  "roleplay-act-it-out": "シナリオ演技",
  "roleplay-act-it-out-listening": "シナリオ演技リスニング",
  "roleplay-act-it-out-speaking": "シナリオ演技スピーキング",
  "roleplay-act-it-out-listening-speaking": "シナリオ演技リスニングとスピーキング",
  "generate_discussion": "ディスカッションを生成",
  "generating_discussion": "ディスカッションを生成中",
  "discuss_prompt_language": "ディスカッションプロンプトの言語を選択",
  "level": "レベル",
  "grouped_discussion": "グループディスカッション",
  "not_present": "ディスカッションに参加していませんでした",
  "view_recording": "録画を表示",
  "generate_feedback": "フィードバックを生成",
  "generate_feedback_for_all": "全員のフィードバックを生成",
  "performance_rating": "パフォーマンス評価",
  "feedback_submitted": "フィードバックが提出されました",
  "group_not_submitted": "グループはまだ録画を提出していません",
  "this_classroom_is_archived": "このクラスルームはアーカイブされています",
  "submission_graded": "提出が評価されました",
  "view_submission": "提出を表示",
  "show_more": "さらに表示",
  "show_less": "表示を減らす",
  "submit_feedback_confirmation": "すべての生成されたフィードバックをレビューし、学習者に提出する準備はできていますか？",
  "submit_feedback_scroll": "学習者に提出する前にすべてのフィードバックをレビューしてください",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "コーストピック",
  "discussion_topic_helper": "ディスカッションの生成を支援するために関連するトピックを選択してください。",
  "no_groups_created_yet": "まだグループが作成されていません",
  "select_students_from_the_list": "グループを作成するために左のリストから学習者を選択してください",
  "drop_members_here": "グループを作成するために学習者をここにドロップしてください",
  "drag_a_student_here": "グループを作成するために学習者をここにドラッグしてください",
  "new_group": "新しいグループ",
  "cannot_edit_discussion": "既存の提出があるディスカッションは編集できません",
  "generating_feedback": "フィードバックを生成中",
  "conversations_graded_success": "フィードバックが生成されました",
  "below_level": "レベル以下",
  "at_level": "レベル通り",
  "above_level": "レベル以上",
  "ai_performance_assessment": "AIパフォーマンス評価",
  "performance_chip_tooltip": "AI分析に基づいて、学習者のパフォーマンスが期待される習熟度範囲と比較してどうかを示します。",
  "performance_chip_note": "教師のみに表示され、指導レビューをサポートすることを目的としています。",
  "progress": "進捗",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "select_the_correct_phrase": "この定義に合う正しいフレーズを選んでください",
  "chinese": "中国語",
  "custom_feedback_placeholder": "現在形の使い方がとても良いです",
  "generate_feedback_view_the": "参照する",
  "generate_feedback_rubric_name": "分析的成長ルーブリック",
  "generate_feedback_rubric_desc": "AIフィードバックで使用されている評価基準。",
  "late_submission": "遅れた提出",
  "days_late_one": "{{count}}日遅れ",
  "days_late_other": "{{count}}日遅れ",
  "generate_definitions": "定義を生成",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "フレーズリスト",
  "no_phrase_lists": "フレーズリストなし",
  "all_phrase_lists": "すべてのフレーズリスト",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "定義の生成中に問題が発生しました。もう一度お試しください。",
  "saving_defintions_error": "定義の保存中に問題が発生しました。もう一度お試しください。",
  "auto_generate_definitions": "定義を生成する",
  "generating_definitions": "定義を生成中",
  "definitions": "定義",
  "view_phrase_list": "フレーズ一覧を見る",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "コピー先",
  "transfer": "コピー",
  "create_phrase_list_from_selection": "新しいフレーズリストを作成",
  "no_other_phrase_lists": "他のフレーズリストはありません",
  "add_row": "行を追加",
  "problem_updating": "更新中に問題が発生しました",
  "exercise_settings": "演習設定",
  "excercise_voice": "演習の音声",
  "excercise_voice_desc": "このフレーズリストの演習で使用する音声を選択します。",
  "excercise_visibility": "演習の表示",
  "keyboard": "キーボード",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "読み書き練習へようこそ",
  "read_write_exercise_definition": "定義",
  "read_write_exercise_definition_desc": "ここに表示された定義を読んでください",
  "read_write_exercise_options": "フレーズを入力",
  "read_write_exercise_options_desc": "テキストボックスに正しいフレーズを入力してください",
  "read_the_definition": "定義を読む",
  "type_the_correct_phrase": "正しいフレーズを入力",
  "read_write": "読み書き",
  "meaning_read_write": "意味 - 読み書き",
  "meaning_read_write_exercise_desc": "定義を読んで、正しいフレーズを入力してください。",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "チャットボットを作成",
  "find_chatbot": "チャットボットを探す",
  "find_chatbots": "チャットボットを探す",
  "add_chatbot": "チャットボットを追加",
  "add_chatbots": "チャットボットを追加",
  "template": "テンプレート",
  "chatbot_name": "チャットボット名",
  "create_scenario": "シナリオを作成",
  "find_scenario": "シナリオを探す",
  "find_scenarios": "シナリオを探す",
  "scenario_name": "シナリオ名",
  "scenarios_added": "シナリオをトピックに追加しました",
  "chatbots_added": "チャットボットをトピックに追加しました",
  "add_scenarios": "シナリオを追加",
  "achievements": "実績",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "他の先生が作成したトピックは<1>コミュニティ</1>タブで見つけられます。",
  "chatbot_title": "チャットボット",
  "open_ended": "自由回答",
  "open_ended_desc": "学習者が自分の言葉で答えられるようにします。",
  "quiz": "クイズ",
  "quiz_desc": "一連の質問で学習者を導きます。",
  "picture_quiz": "画像クイズ",
  "picture_quiz_desc": "画像に基づいて質問をします。",
  "emoji_quiz": "絵文字クイズ",
  "emoji_quiz_desc": "絵文字を見て答えを推測してください。",
  "quiz_style_templates": "クイズ形式のテンプレート",
  "no_scenarios_found": "シナリオが見つかりません",
  "no_chatbots_found": "チャットボットが見つかりません",
  "use_voice": "音声を使用",
  "internal_view_provider_marks": "内部ビュー · プロバイダーの採点を表示",
  "legacy": "レガシー",
  "scan_to_open_the_classroom": "スキャンしてクラスルームを開く",
  "classroom_link": "クラスルームリンク",
  "copy": "コピー",
  "tell_students_to": "学習者に次のことを伝えてください",
  "invite_step_sign_in": "アカウントにサインインします。",
  "invite_step_scan": "コードをスキャンするか、クラスルームを開きます。",
  "invite_step_tap_join": "{{button}} をタップします。",
  "select_exercise_phrases_intro": "プレイしたいフレーズリストにチェックを入れてください。異なるコースのリストを組み合わせることもできます。",
  "select_exercise_scenarios_intro": "クラスとライブでプレイするシナリオを選択してください。",
  "source_type_phrase_lists": "フレーズリスト",
  "source_type_scenarios": "シナリオ",
  "clear_all": "すべてクリア",
  "n_of_m_lists_selected": "{{m}} 件中 {{n}} 件のリストを選択",
  "n_phrase_lists": "{{count}} 件のフレーズリスト",
  "n_phrases": "{{count}} 個のフレーズ",
  "has_definitions": "定義あり",
  "n_scenarios": "{{count}} 件のシナリオ",
  "n_messages": "{{count}} 件のメッセージ",
  "n_interactions": "{{count}} 回の相互作用",
  "lists_and_phrases_selected": "{{lists}} 件のリスト · {{phrases}} 個のフレーズ",
  "no_lists_selected": "リストが選択されていません",
  "no_scenario_selected": "シナリオが選択されていません",
  "scenario_selected": "シナリオを選択しました",
  "number_of_messages": "メッセージ数",
  "max_phrases_label": "最大",
  "max_phrases_all": "全 {{count}} 件",
  "estimated_game_time_hint": "各 {{seconds}} 秒で {{questions}} 問、加えてラウンド間のフィードバック。",
  "n_minutes": "{{count}} 分",
  "live_game_title": "{{exercise}} · {{count}} 件のフレーズリスト",
  "phrases_from": "フレーズの出典",
  "source_card_meta": "{{topic}} · {{count}} 個のフレーズ",
  "n_more": "他",
  "waiting_for_students": "学習者の参加を待っています。",
  "how_students_answer": "学習者の回答方法",
  "answer_keyboard_and_word_bank": "キーボードと単語バンク",
  "answer_keyboard_and_word_bank_hint": "学習者は入力し、必要に応じて単語タイルを使えます。",
  "answer_keyboard_only": "キーボードのみ",
  "answer_keyboard_only_hint": "最難関 — 学習者が答え全体を入力します。",
  "answer_word_bank_only": "単語バンクのみ",
  "answer_word_bank_only_hint": "最も簡単 — 学習者が単語をタップして並べます。",
  "time_per_question": "1問あたりの時間",
  "all_n_phrases": "全 {{count}} 個のフレーズ",
  "includes_one_from_each_list": "選択した各リストから少なくとも1つのフレーズが必ず含まれます。",
  "newest": "新しい順",
  "oldest": "古い順",
  "az": "A–Z",
  "clear_filters": "フィルターをクリア",
  "search_sections_and_topics": "セクションとトピックを検索",
  "clear_search": "検索をクリア",
  "x_of_y": "{{shown}} / {{total}}",
  "outline_filter_count": "{{sections}}中 {{topics}}",
  "topic_count_one": "{{count}}件のトピック",
  "topic_count_other": "{{count}}件のトピック",
  "section_count_one": "{{count}}セクション",
  "section_count_other": "{{count}}セクション",
  "no_sections_or_topics_match": "一致するセクションやトピックはありません",
  "try_different_keyword_or_difficulty": "別のキーワードまたは難易度をお試しください。",
  "nothing_matches_keyword_at_difficulty": "難易度{{difficulty}}で「{{keyword}}」に一致するものはありません。別のキーワードまたは難易度をお試しください。",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "session_feedback": "あなたへのフィードバック",
  "session_feedback_preparing": "フィードバックを準備しています…",
  "session_feedback_unavailable": "フィードバックは現在表示できません。",
  "suggested_level": "推奨レベル",
  "session_report": "会話のフィードバック",
  "view_full_report": "フィードバック全体を見る",
  "rating_approaching": "もう少し",
  "rating_meets": "達成",
  "rating_exceeds": "上回る",
  "area_of_strength": "強み",
  "area_for_growth": "伸ばすポイント",
  "rating_not_yet": "まだ",
  "session_report_short_interaction": "やり取り",
  "session_report_short_vocabulary": "語彙",
  "session_report_short_function": "機能",
  "session_report_strength": "強み",
  "session_report_growth": "伸びしろ",
  "ai_generated_report": "AI が作成したフィードバック",
  "ai_generated_report_tooltip": "このセッションのみに基づいて AI が作成しました。推奨レベルと評価は目安であり、最終的な判定ではありません。",
  "session_report_new": "新着",
  "chatbot_mode_name": "チャットボット - {{mode}}",
  "chatbot_message_count": "{{count}} 件のメッセージ",
  "chatbot_message_count_other": "{{count}} 件のメッセージ",
  "attempt_count": "{{count}}回の解答",
  "attempt_count_one": "{{count}}回の解答",
  "attempt_count_other": "{{count}}回の解答",
  "of_total_correct": "/ {{total}} 正解",
  "attempts_to_review": "見直す解答",
  "attempts_not_shown": "{{items, list}}の解答は表示されていません",
  "count_correct": "正解 {{count}}",
  "count_incorrect": "不正解 {{count}}",
  "count_skipped": "スキップ {{count}}",
  "count_partially_correct": "部分的に正解 {{count}}",
  "view_all_count": "すべて表示（{{count}}）",
  "view_attempt": "解答を見る",
  "scenario_description_default": "これは、学習者が自信を持って{{learnLang}}を話せるようにするためのシナリオです。"
}
